
// import React, { useState, useEffect, useCallback } from 'react';
// import logoImg from '../assets/logo.jpg';
// import '../styles/OKRTracker.css';

// const OKRTracker = ({ userData: propUserData, defaultTab }) => {

//   const [lockedQuarters, setLockedQuarters] = useState({});

//   const [activeTab, setActiveTab] = useState("OKR Tracker");

//   /* ---------- FINANCIAL YEAR & QUARTER LOGIC ---------- */
//   const today = new Date();
//   const currentMonth = today.getMonth() + 1;

//   const getFY = (date) => {
//     const m = date.getMonth() + 1;
//     const y = date.getFullYear();
//     return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//   };

//   const getCurrentQuarterLimit = (month) => {
//     if (month >= 4 && month <= 6) return 'Quarter 1';
//     if (month >= 7 && month <= 9) return 'Quarter 2';
//     if (month >= 10 && month <= 12) return 'Quarter 3';
//     return 'Quarter 4';
//   };

//   const [userData, setUserData] = useState(null);
//   const [isSyncing, setIsSyncing] = useState(false);
//   const [isTimelineLockedFromDB, setIsTimelineLockedFromDB] = useState(false);
//   const [selectedYear, setSelectedYear] = useState(getFY(today));
//   const [selectedQuarter, setSelectedQuarter] = useState("");

//   const [history, setHistory] = useState([]);
//   const [workflowStep, setWorkflowStep] = useState('Planning');
//   const [showModal, setShowModal] = useState(false);
//   const [modalMsg, setModalMsg] = useState('');

//   /* ---------- EMPLOYEE REVIEW STATE ---------- */
//   const [reviewData, setReviewData] = useState({
//     review_period: '',
//     job_title: '',
//     achievements: Array(5).fill(''),
//     responsibilities: Array(5).fill(''),
//     skills_growth: Array(5).fill(''),
//     challenges: Array(5).fill(''),
//     improvement_areas: Array(5).fill(''),
//     goals_next_year: Array(5).fill(''),
//     additional_contributions: Array(5).fill(''),
//     support_needed: Array(5).fill('')
//   });

//   const [okrRows, setOkrRows] = useState([
//     {
//       id: Date.now(),
//       objective: '',
//       keyResults: Array.from({ length: 6 }, () => ({ text: '', result: 'Pending' }))
//     }
//   ]);

//   const resultOptions = ['Pending', 'Not Met/ Downgraded', 'Successfull', 'Exceeds', 'Excellence'];
//   const quarterOptions = ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'];
//   const yearOptions = ["2024-2025", "2025-2026", "2026-2027"];

//   /* ---------- AUTO-RESIZE LOGIC ---------- */
//   const autoResize = (target) => {
//     if (target) {
//       target.style.height = 'auto';
//       target.style.height = `${target.scrollHeight}px`;
//     }
//   };

//   // Re-run resize when tabs change or data loads
//   useEffect(() => {
//     const textareas = document.querySelectorAll('.obj-textarea, .kr-single-textarea, .doc-point-textarea');
//     textareas.forEach(el => autoResize(el));
//   }, [okrRows, activeTab, reviewData]);

//   useEffect(() => {
//     if (propUserData) {
//       setUserData({
//         EmpId: propUserData.EmpId || propUserData.id,
//         DisplayName: `${propUserData.firstName || ''} ${propUserData.lastName || ''}`.trim(),
//         Department: propUserData.Department || ''
//       });
//     }
//   }, [propUserData]);



//   useEffect(() => {
//     const fetchAllLocks = async () => {
//       try {
//         const res = await fetch(
//           `/gt-api/get_timeline_lock.php?year=${selectedYear}`
//         );
//         const data = await res.json();

//         if (data.success && data.data) {
//           const lockMap = {};
//           data.data.forEach(item => {
//             lockMap[item.quarter] = item.locked == 1;
//           });
//           setLockedQuarters(lockMap);
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     if (selectedYear) fetchAllLocks();
//   }, [selectedYear]);

//   const loadExistingOKR = useCallback(async (year, quarter, force = false) => {
//     if (!userData?.EmpId || !year || !quarter) return;

//     try {
//       const res = await fetch(
//         `/gt-api/get_user_okr.php?empId=${userData.EmpId}&year=${year}&quarter=${quarter}`
//       );

//       const data = await res.json();

//       if (data.success) {

//         // ✅ DEEP CLONE (VERY IMPORTANT)
//         const parsedRaw =
//           typeof data.data === 'string'
//             ? JSON.parse(data.data)
//             : data.data;

//         const parsed = JSON.parse(JSON.stringify(parsedRaw));

//         // ✅ CLEAN + REBUILD DATA
//         const cleanedData = parsed.map((obj) => {
//   return {
//     ...obj,
//     id: obj.id || `${Date.now()}-${Math.random()}`, // 🔥 ensure unique objective id
//     keyResults: Array.from({ length: 6 }, (_, i) => {
//       const kr = obj.keyResults?.[i] || {};

//       const newKR = {
//         text: kr.text ? String(kr.text) : '',
//         result: kr.result ? String(kr.result) : 'Pending',
//         ar_comment: kr.ar_comment ? String(kr.ar_comment) : '',
//         _krId: `${i}-${Date.now()}-${Math.random()}` // 🔥 UNIQUE PER KR
//       };

//       if (
//         data.workflow_status === 'Scoring' ||
//         data.workflow_status === 'Sign_Off' ||
//         data.workflow_status === 'Locked'
//       ) {
//         delete newKR.ar_comment;
//       }

//       return { ...newKR }; // 🔥 force new object
//     })
//   };
// });

//         setOkrRows(cleanedData);
//         setWorkflowStep(data.workflow_status);

//       } else if (force || !data.success) {

//         setWorkflowStep('Planning');

//         setOkrRows([
//           {
//             id: Date.now(),
//             objective: '',
//             keyResults: Array.from({ length: 6 }, () => ({
//               text: '',
//               result: 'Pending'
//             }))
//           }
//         ]);
//       }

//     } catch (err) {
//       console.error(err);
//     }
//   }, [userData]);

//   useEffect(() => {
//     if (selectedQuarter) {
//       loadExistingOKR(selectedYear, selectedQuarter);
//     }
//   }, [selectedYear, selectedQuarter, loadExistingOKR]);

//   useEffect(() => {
//     const fetchLock = async () => {
//       try {
//         const res = await fetch(
//           `/gt-api/get_timeline_lock.php?year=${selectedYear}&quarter=${selectedQuarter}`
//         );
//         const data = await res.json();
//         console.log("CHECK LOCK API:", selectedYear, selectedQuarter);

//         if (data.success) {
//           setIsTimelineLockedFromDB(data.locked === true || data.locked === "true" || data.locked == 1);
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     if (selectedYear && selectedQuarter) {
//       fetchLock();
//     }
//   }, [selectedYear, selectedQuarter]);

//   const fetchHistory = useCallback(async () => {
//     if (!userData?.EmpId) return;
//     try {
//       const res = await fetch(`/gt-api/get_okr_history.php?empId=${userData.EmpId}`);
//       const data = await res.json();
//       setHistory(data || []);
//     } catch (err) { console.error(err); }
//   }, [userData]);

//   useEffect(() => {
//     fetchHistory();
//   }, [fetchHistory]);

//   useEffect(() => {
//     if (defaultTab) {
//       setActiveTab(defaultTab);
//     }
//   }, [defaultTab]);

//   const getQuarterStatusLabel = (q) => {
//     const record = history.find(h => h.quarter === q && h.year.toString() === selectedYear.toString());
//     if (!record) return "";
//     const status = record.workflow_status;
//     if (status === 'Locked' || status === 'Sign_Off') return " (Locked)";
//     return ` (${status.replace(/_/g, ' ')})`;
//   };

//   const handleInputChange = (id, field, value, krIndex = null) => {
//     setOkrRows(prev => prev.map(row => {
//       if (row.id !== id) return row;
//       if (krIndex !== null) {
//         const krs = [...row.keyResults];
//         krs[krIndex] = { ...krs[krIndex], [field]: value };
//         return { ...row, keyResults: krs };
//       }
//       return { ...row, [field]: value };
//     }));
//   };

//   const handleReviewChange = (sectionId, index, value) => {
//     setReviewData(prev => {
//       const updatedSection = [...prev[sectionId]];
//       updatedSection[index] = value;
//       return { ...prev, [sectionId]: updatedSection };
//     });
//   };

//   const addNewObjective = () => {
//     if (okrRows.length >= 6) return;
//     setOkrRows(prev => [...prev, {
//       id: Date.now(),
//       objective: '',
//       keyResults: Array.from({ length: 6 }, () => ({ text: '', result: 'Pending' }))
//     }]);
//   };

//   const deleteObjective = (id) => {
//     if (okrRows.length === 1) return;
//     setOkrRows(prev => prev.filter(o => o.id !== id));
//   };

//   const [managementNotices, setManagementNotices] = useState({ reviews: [], probations: [] });

//   const fetchNotices = useCallback(async () => {
//     if (!userData?.EmpId) return;
//     try {
//       const res = await fetch(`/gt-api/get_manager_feedback.php?empId=${userData.EmpId}`);
//       const data = await res.json();
//       if (data.success) {
//         setManagementNotices({
//           reviews: data.reviews || [],
//           probations: data.probations || []
//         });
//       }
//     } catch (err) { console.error(err); }
//   }, [userData]);

//   useEffect(() => {
//     if (activeTab === "Manager Review") {
//       fetchNotices();
//       localStorage.setItem("seen_reviews", new Date().toISOString());
//     }

//     if (activeTab === "Probation Period Feedback") {
//       fetchNotices();
//       localStorage.setItem("seen_probation", new Date().toISOString());
//     }
//   }, [activeTab, fetchNotices]);

//   const handleViewFromLog = (year, quarter) => {
//     setSelectedYear(year);
//     setSelectedQuarter(quarter);
//     loadExistingOKR(year, quarter, true);
//     setActiveTab("OKR Tracker");
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   const syncToGenesis = async () => {
//     if (!selectedYear || !selectedQuarter) {
//       alert("Please select a quarter first.");
//       return;
//     }

//     if (
//       isTimelineLockedFromDB &&
//       workflowStep !== 'Returned_To_Employee' &&
//       workflowStep !== 'Scoring'
//     ) {
//       alert("This quarter is locked.");
//       return;
//     }

//     setIsSyncing(true);

//     try {
//       const res = await fetch('/gt-api/submit_okr.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           empId: userData.EmpId,
//           empName: userData.DisplayName,
//           department: userData.Department,
//           year: selectedYear,
//           quarter: selectedQuarter,
//           okrData: okrRows,
//           status:
//             workflowStep === 'Planning' || workflowStep === 'Returned_To_Employee'
//               ? 'Management_Review'
//               : 'Manager_Scoring_Review'
//         })
//       });

//       const text = await res.text();
//       console.log("RAW RESPONSE:", text);

//       let data;
//       try {
//         data = JSON.parse(text);
//       } catch {
//         // 🔥 even if JSON fails → assume success (since DB saved)
//         setModalMsg("Saved successfully!");
//         setShowModal(true);
//         fetchHistory();
//         return;
//       }

//       // ✅ flexible success handling
//       if (data.success || data.status === "ok") {
//         setModalMsg("Saved successfully!");
//         setShowModal(true);
//         fetchHistory();
//       } else {
//         alert("Something went wrong: " + (data.message || text));
//       }

//     } catch (err) {
//       console.error(err);
//       alert("Network error. Failed to save.");
//     } finally {
//       setIsSyncing(false);
//     }
//   };


//   const submitSelfReview = async (e) => {
//     e.preventDefault();
//     setIsSyncing(true);
//     try {
//       const res = await fetch('/gt-api/submit_employee_review.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           empid: userData.EmpId,
//           full_name: userData.DisplayName,
//           team: userData.Department,
//           job_title: reviewData.job_title,
//           review_period: reviewData.review_period,
//           achievements: reviewData.achievements,
//           responsibilities: reviewData.responsibilities,
//           skills_growth: reviewData.skills_growth,
//           challenges: reviewData.challenges,
//           improvement_areas: reviewData.improvement_areas,
//           goals_next_year: reviewData.goals_next_year,
//           additional_contributions: reviewData.additional_contributions,
//           support_needed: reviewData.support_needed
//         })
//       });
//       const data = await res.json();

//       if (data.success) {
//         setModalMsg("Your self-review has been submitted successfully!");
//         setShowModal(true);
//       } else {
//         alert("Failed to submit review: " + data.message);
//       }
//     } catch { alert("Network error. Failed to submit review."); } finally { setIsSyncing(false); }
//   };

//   const canEditOKR =
//     (
//       (!isTimelineLockedFromDB && workflowStep === 'Planning') ||
//       workflowStep === 'Returned_To_Employee'
//     ) &&
//     selectedQuarter !== "";

//   const canScore =
//     workflowStep === 'Scoring' &&
//     (workflowStep === 'Scoring') &&
//     selectedQuarter !== "";
//   const updateProgress = async () => {
//     if (!selectedYear || !selectedQuarter) return;

//     setIsSyncing(true);

//     try {
//       const res = await fetch('/gt-api/update_okr_progress.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           empId: userData.EmpId,
//           year: selectedYear,
//           quarter: selectedQuarter,
//           okrData: okrRows
//         })
//       });

//       const data = await res.json();

//       console.log("SERVER RESPONSE:", data);

//       if (data.success) {
//         setModalMsg("Progress updated successfully!");
//         setShowModal(true);

//         // ❌ old (keep or remove, doesn't matter)
//         localStorage.setItem("okr_updated", Date.now());

//         // ✅ ADD THIS (THIS IS THE REAL FIX)
//         window.dispatchEvent(new Event("okrUpdated"));
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Network error");
//     } finally {
//       setIsSyncing(false);
//     }
//   };
//   const isEmployeeTurn = ['Planning', 'Scoring', 'Returned_To_Employee'].includes(workflowStep);

//   const isLocked = workflowStep === 'Locked' || workflowStep === 'Sign_Off';



//   const renderSubModule = () => {
//     switch (activeTab) {
//       case "OKR Tracker":
//         return (
//           <div className="okr-genesis-container">
//             {showModal && (
//               <div className="modal-overlay" style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'fixed', inset: 0, zIndex: 1000 }}>
//                 <div className="okr-success-modal animate-pop" style={{ backgroundColor: '#ffffff', padding: '40px', borderRadius: '16px', textAlign: 'center', maxWidth: '400px', width: '90%', boxShadow: '0 20px 40px rgba(0,0,0,0.2)' }}>
//                   <div className="success-icon-container" style={{ backgroundColor: '#e8f5e9', width: '60px', height: '60px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
//                     <div className="check-mark" style={{ color: '#2e7d32', fontSize: '30px', fontWeight: 'bold' }}>✓</div>
//                   </div>
//                   <h2 style={{ color: '#1a1a1a', marginBottom: '10px', fontSize: '1.5rem' }}>All Set!</h2>
//                   <p style={{ color: '#666666', marginBottom: '30px', lineHeight: '1.5' }}>{modalMsg}</p>
//                   <button className="btn-modal-continue" onClick={() => window.location.reload()} style={{ backgroundColor: '#2196F3', color: '#ffffff', border: 'none', padding: '12px 30px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', width: '100%' }}>CONTINUE</button>
//                 </div>
//               </div>
//             )}

//             <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
//               <div className="okr-glass-card" style={{ width: '100%' }}>
//                 <header className="okr-view-header">
//                   <div className="title-group">
//                     <div className="status-badge"><span className="pulse-ring"></span></div>
//                     <h1>OKR <span className="blue-gradient-text">Tracker</span></h1>
//                   </div>
//                   <div className="header-actions">
//                     <select className="time-select-modern" value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
//                       {yearOptions.map(y => <option key={y} value={y}>{y}</option>)}
//                     </select>

//                     <select
//                       className="time-select-modern"
//                       value={selectedQuarter}
//                       onChange={(e) => setSelectedQuarter(e.target.value)}
//                     >
//                       <option value="" disabled>Select Quarter</option>

//                       {quarterOptions.map(q => {
//                         const currentQuarter = getCurrentQuarterLimit(currentMonth);
//                         const isCurrentYear = selectedYear === getFY(today);

//                         const isFutureQuarter =
//                           isCurrentYear &&
//                           quarterOptions.indexOf(q) > quarterOptions.indexOf(currentQuarter);

//                         // 🔥 USE EXISTING STATE (NO NEW API)
//                         const isLockedFromDB =
//                           selectedQuarter === q && isTimelineLockedFromDB;

//                         const isDisabled = isFutureQuarter || isLockedFromDB;

//                         return (
//                           <option key={q} value={q} disabled={isDisabled}>
//                             {q} {isLockedFromDB ? "🔒 Locked" : ""}
//                           </option>
//                         );
//                       })}
//                     </select>

//                     <span className="node-count">
//                       {userData ? `${userData.DisplayName.toUpperCase()} | ${isLocked ? 'LOCKED' : workflowStep.replace(/_/g, ' ')}` : "CONNECTING..."}
//                     </span>
//                   </div>
//                 </header>

//                 <div className="okr-table-wrapper">
//                   <table className="okr-modern-table">
//                     <thead>
//                       <tr><th width="35%">Goal Objective</th><th width="45%">Key Results (6)</th><th width="20%">Status</th></tr>
//                     </thead>
//                     <tbody>
//                       {okrRows.map((row, rowIdx) => (
//                         <React.Fragment key={row.id}>
//                           {row.keyResults.map((kr, idx) => (
//                             <tr
//                             key={kr._krId || `${row.id}-${idx}`}
//                               className={`data-row ${idx === row.keyResults.length - 1 ? 'block-end' : ''}`}
//                             >
//                               {idx === 0 && (
//                                 <td rowSpan={row.keyResults.length} className="objective-spanned-cell">
//                                   <div className="obj-header-row">
//                                     <div className="obj-number">
//                                       Goal {rowIdx + 1}
//                                     </div>

//                                     {(
//                                       (workflowStep === 'Returned_To_Employee') ||
//                                       !isTimelineLockedFromDB
//                                     ) && canEditOKR && okrRows.length > 1 && (
//                                         <button
//                                           className="btn-delete-obj"
//                                           onClick={() => deleteObjective(row.id)}
//                                         >
//                                           ✕
//                                         </button>
//                                       )}
//                                   </div>

//                                   <textarea
//                                     className="obj-textarea"
//                                     placeholder={
//                                       selectedQuarter
//                                         ? "What is your main focus?..."
//                                         : "Select a quarter to begin..."
//                                     }
//                                     value={row.objective}
//                                     disabled={!canEditOKR}
//                                     onChange={(e) => {
//                                       handleInputChange(row.id, 'objective', e.target.value);
//                                       autoResize(e.target);
//                                     }}
//                                   />
//                                 </td>
//                               )}

//                               <td className="kr-cell">
//                                 <div className="kr-input-wrapper">
//                                   <span className="kr-index">
//                                     0{idx + 1}
//                                   </span>

//                                   <textarea
//                                     className="kr-single-textarea"
//                                     placeholder="Key measure..."
//                                     value={kr.text}
//                                     disabled={!canEditOKR}
//                                     onChange={(e) => {
//                                       handleInputChange(row.id, 'text', e.target.value, idx);
//                                       autoResize(e.target);
//                                     }}
//                                   />
//                                 </div>

//                                 {kr.ar_comment && (
//                                   <div
//                                     style={{
//                                       marginTop: '6px',
//                                       padding: '8px',
//                                       borderRadius: '6px',
//                                       background: 'rgba(255,152,0,0.08)',
//                                       borderLeft: '3px solid #ff9800',
//                                       fontSize: '12px',
//                                     }}
//                                   >
//                                     <strong>AR:</strong> {kr.ar_comment}
//                                   </div>
//                                 )}
//                               </td>

//                               <td>
//                                 <select
//                                   className="modern-select"
//                                   value={kr.result}
//                                   disabled={!canScore}
//                                   onChange={(e) =>
//                                     handleInputChange(row.id, 'result', e.target.value, idx)
//                                   }
//                                 >
//                                   {resultOptions.map((opt) => (
//                                     <option key={opt} value={opt}>
//                                       {opt}
//                                     </option>
//                                   ))}
//                                 </select>
//                               </td>
//                             </tr>
//                           ))}
//                         </React.Fragment>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>

//                 <footer className="okr-footer">
//                   <div className="footer-left">
//                     {((workflowStep === 'Returned_To_Employee') || !isTimelineLockedFromDB) && canEditOKR && okrRows.length < 6 && (
//                       <button className="btn-add-objective" onClick={addNewObjective}>+ Add another Goal ({okrRows.length}/6)</button>
//                     )}
//                   </div>
//                   <div className="footer-right">

//                     {/* 🔥 NEW BUTTON */}
//                     {canScore && !isLocked && (
//                       <button
//                         className="btn-secondary"
//                         onClick={updateProgress}
//                         disabled={isSyncing}
//                       >
//                         {isSyncing ? "Updating..." : "Update Progress"}
//                       </button>
//                     )}

//                     {/* EXISTING BUTTON */}
//                     {selectedQuarter &&
//                       isEmployeeTurn &&
//                       !isLocked &&
//                       (
//                         workflowStep === 'Returned_To_Employee' ||
//                         workflowStep === 'Scoring' ||
//                         !isTimelineLockedFromDB
//                       ) && (
//                         <button className="btn-primary" onClick={syncToGenesis} disabled={isSyncing}>
//                           {isSyncing
//                             ? "Saving..."
//                             : workflowStep === 'Returned_To_Employee'
//                               ? "Resubmit"
//                               : workflowStep === 'Planning'
//                                 ? "Send for Review"
//                                 : "Submit"}
//                         </button>
//                       )}

//                   </div>
//                 </footer>
//               </div>

//               <div className="okr-glass-card" style={{ width: '100%', padding: '20px' }}>
//                 <h3 className="blue-gradient-text" style={{ fontSize: '1.1rem', marginBottom: '15px' }}>MY HISTORY</h3>
//                 <div className="okr-table-wrapper">
//                   {isTimelineLockedFromDB && (
//                     <div style={{
//                       background: "#ff4d4f",
//                       color: "#fff",
//                       padding: "10px",
//                       borderRadius: "6px",
//                       textAlign: "center",
//                       fontWeight: "600",
//                       marginBottom: "10px"
//                     }}>
//                       🔒 This quarter is locked by management
//                     </div>
//                   )}
//                   <table className="okr-modern-table">
//                     <thead>
//                       <tr><th>Period</th><th>Submitted On</th><th>Status</th><th style={{ textAlign: 'right' }}>Action</th></tr>
//                     </thead>
//                     <tbody>
//                       {history.map((item) => (
//                         <tr key={item.id} className="data-row">
//                           <td style={{ fontWeight: '600' }}>{item.quarter} {item.year}</td>
//                           <td style={{ opacity: 0.6 }}>{new Date(item.submitted_at).toLocaleDateString()}</td>
//                           <td>
//                             <span className="status-pill-mini">
//                               {item.workflow_status === 'Locked' || item.workflow_status === 'Sign_Off' ? '🔒 Locked' : item.workflow_status.replace(/_/g, ' ')}
//                             </span>
//                           </td>
//                           <td style={{ textAlign: 'right' }}>
//                             <button className="btn-view-data" onClick={() => handleViewFromLog(item.year, item.quarter)}>VIEW DATA</button>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>


//               </div>
//             </div>
//           </div>
//         );




//       case "Employee Self Performance Review":
//         return (
//           <div className="okr-genesis-container animate-fade">
//             {showModal && (
//               <div className="modal-overlay" style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'fixed', inset: 0, zIndex: 1000, backdropFilter: 'blur(10px)' }}>
//                 <div className="okr-success-modal animate-pop" style={{ background: '#111', border: '1px solid #00bcd4', padding: '40px', borderRadius: '20px', textAlign: 'center', maxWidth: '400px', width: '90%' }}>
//                   <div style={{ fontSize: '40px', marginBottom: '15px' }}>📋</div>
//                   <h2 className="blue-gradient-text">Review Submitted</h2>
//                   <p style={{ color: 'rgba(255,255,255,0.7)', marginBottom: '25px' }}>{modalMsg}</p>
//                   <button className="btn-modal-continue" onClick={() => window.location.reload()} style={{ background: '#00bcd4', color: '#000', border: 'none', padding: '12px 25px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>OK</button>
//                 </div>
//               </div>
//             )}

//             <div className="review-document-container" style={{ maxWidth: '950px', margin: '0 auto', paddingBottom: '50px' }}>
//               <div className="review-doc-paper" style={{ background: 'rgba(255, 255, 255, 0.03)', backdropFilter: 'blur(20px)', border: '1px solid rgba(255, 255, 255, 0.1)', borderRadius: '12px', padding: '50px' }}>

//                 <div className="doc-header-grid" style={{ display: 'flex', gap: '40px', borderBottom: '2px solid #00bcd4', paddingBottom: '30px', marginBottom: '40px' }}>
//                   <div className="doc-logo-section">
//                     <img src={logoImg} alt="Logo" style={{ maxWidth: '140px', height: 'auto', filter: 'brightness(1.2)' }} />
//                   </div>
//                   <div className="doc-title-section">
//                     <h1 style={{ fontSize: '2.2rem', fontWeight: '800', margin: '0 0 10px 0', color: '#fff' }}>Employee Annual Self-Review Form</h1>
//                     <p style={{ fontSize: '0.95rem', lineHeight: '1.6', opacity: 0.7, color: '#fff' }}>
//                       Please complete this self-review to reflect on your performance. <strong>Provide 5 points for each section.</strong>
//                     </p>
//                   </div>
//                 </div>

//                 <form onSubmit={submitSelfReview}>
//                   <div className="doc-section" style={{ marginBottom: '40px' }}>
//                     <h3 style={{ color: '#00bcd4', textTransform: 'uppercase', fontSize: '0.85rem', letterSpacing: '2px', marginBottom: '20px' }}>SECTION 1 — Basic Information</h3>
//                     <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
//                       <div className="doc-field">
//                         <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.6, marginBottom: '5px', color: '#fff' }}>1. Full Name:</label>
//                         <input type="text" className="doc-underlined-input" value={userData?.DisplayName} readOnly />
//                       </div>
//                       <div className="doc-field">
//                         <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.6, marginBottom: '5px', color: '#fff' }}>2. Job Title:</label>
//                         <input type="text" className="doc-underlined-input" placeholder="Your Title..." onChange={(e) => setReviewData({ ...reviewData, job_title: e.target.value })} />
//                       </div>
//                       <div className="doc-field">
//                         <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.6, marginBottom: '5px', color: '#fff' }}>3. Team:</label>
//                         <input type="text" className="doc-underlined-input" value={userData?.Department} readOnly />
//                       </div>
//                       <div className="doc-field">
//                         <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.6, marginBottom: '5px', color: '#fff' }}>4. Review Period:</label>
//                         <input type="text" className="doc-underlined-input" placeholder="Jan 2025 – Dec 2025" required onChange={(e) => setReviewData({ ...reviewData, review_period: e.target.value })} />
//                       </div>
//                     </div>
//                   </div>

//                   {[
//                     { id: 'achievements', title: 'SECTION 2 — Key Achievements', instruction: 'List your top achievements this year:' },
//                     { id: 'responsibilities', title: 'SECTION 3 — Role & Responsibilities', instruction: 'Describe your main responsibilities and any additional tasks:' },
//                     { id: 'skills_growth', title: 'SECTION 4 — Skills & Growth', instruction: 'What new skills or knowledge did you acquire?' },
//                     { id: 'challenges', title: 'SECTION 5 — Challenges', instruction: 'What challenges did you face and how did you handle them?' },
//                     { id: 'improvement_areas', title: 'SECTION 6 — Improvement Areas', instruction: 'What areas do you want to improve next year?' },
//                     { id: 'goals_next_year', title: 'SECTION 7 — Goals for Next Year', instruction: 'List goals you want to work on next year:' },
//                     { id: 'additional_contributions', title: 'SECTION 8 — Additional Contributions', instruction: 'Mention team support, mentoring, or other initiatives:' },
//                     { id: 'support_needed', title: 'SECTION 9 — Support Needed', instruction: 'What resources do you need from your manager?' }
//                   ].map((section) => (
//                     <div className="doc-section" key={section.id} style={{ marginBottom: '35px' }}>
//                       <h3 style={{ color: '#00bcd4', textTransform: 'uppercase', fontSize: '0.85rem', letterSpacing: '2px', marginBottom: '10px' }}>{section.title}</h3>
//                       <p style={{ fontSize: '0.9rem', marginBottom: '15px', fontWeight: '500', color: '#fff' }}>{section.instruction}</p>

//                       <div className="five-point-container" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
//                         {[0, 1, 2, 3, 4].map((idx) => (
//                           <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: '15px', background: 'rgba(255,255,255,0.02)', padding: '10px 15px', borderRadius: '4px' }}>
//                             <span style={{ fontSize: '0.8rem', opacity: 0.4, color: '#00bcd4', fontWeight: 'bold', marginTop: '4px' }}>{idx + 1}.</span>
//                             <textarea
//                               placeholder="..."
//                               className="doc-point-textarea"
//                               rows="1"
//                               value={reviewData[section.id][idx]}
//                               onChange={(e) => {
//                                 handleReviewChange(section.id, idx, e.target.value);
//                                 autoResize(e.target);
//                               }}
//                               style={{
//                                 width: '100%',
//                                 background: 'transparent',
//                                 border: 'none',
//                                 color: '#fff',
//                                 outline: 'none',
//                                 resize: 'none',
//                                 overflow: 'hidden',
//                                 padding: '0',
//                                 lineHeight: '1.5'
//                               }}
//                             />
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   ))}

//                   <div style={{ textAlign: 'center', marginTop: '50px' }}>
//                     <button type="submit" className="doc-submit-btn" disabled={isSyncing} style={{ background: '#00bcd4', color: '#000', border: 'none', padding: '18px 60px', borderRadius: '4px', fontWeight: '800', cursor: 'pointer', transition: '0.3s' }}>
//                       {isSyncing ? "SAVING DATA..." : "SUBMIT COMPLETED REVIEW"}
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         );

//       case "Manager Review":
//         return (
//           <div className="okr-genesis-container animate-fade">
//             <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
//               <h2 className="blue-gradient-text">Manager Review</h2>
//               {managementNotices.reviews.length > 0 ? (
//                 managementNotices.reviews.map((item, index) => (
//                   <div key={index} className="okr-glass-card" style={{ padding: '20px', borderLeft: '4px solid #00bcd4' }}>
//                     <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', opacity: 0.6, fontSize: '0.8rem' }}>
//                       <span>OFFICIAL REVIEW</span>
//                       <span>{new Date(item.created_at).toLocaleDateString()}</span>
//                     </div>
//                     <div style={{ color: '#fff', whiteSpace: 'pre-wrap', lineHeight: '1.6' }}>{item.content}</div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="okr-glass-card" style={{ padding: '20px', textAlign: 'center', opacity: 0.5 }}>No reviews found.</div>
//               )}
//             </div>
//           </div>
//         );

//       case "Probation Period Feedback":
//         return (
//           <div className="okr-genesis-container animate-fade">
//             <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
//               <h2 className="blue-gradient-text">Probation Notice</h2>
//               {managementNotices.probations.length > 0 ? (
//                 managementNotices.probations.map((item, index) => (
//                   <div key={index} className="okr-glass-card" style={{ padding: '20px', borderLeft: '4px solid #ff5252' }}>
//                     <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', opacity: 0.6, fontSize: '0.8rem' }}>
//                       <span>NOTICE OF PROBATION</span>
//                       <span>{new Date(item.created_at).toLocaleDateString()}</span>
//                     </div>
//                     <div style={{ color: '#fff', whiteSpace: 'pre-wrap', lineHeight: '1.6' }}>{item.content}</div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="okr-glass-card" style={{ padding: '20px', textAlign: 'center', opacity: 0.5 }}>No probation notices found.</div>
//               )}
//             </div>
//           </div>
//         );



//       default: return null;
//     }
//   };

//   return (
//     <div className="pay-module">
//       <div className="pay-nav-grid">
//         {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//           <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => setActiveTab(tab)}>
//             {tab.toUpperCase()}
//           </button>
//         ))}
//       </div>
//       <div className="pay-content-area">
//         {renderSubModule()}
//       </div>
//     </div>
//   );
// };

// export default OKRTracker;



































// import React, { useState, useEffect, useCallback } from 'react';
// import logoImg from '../assets/logo.jpg';
// import '../styles/OKRTracker.css';

// const OKRTracker = ({ userData: propUserData, defaultTab }) => {

//     const [lockedQuarters, setLockedQuarters] = useState({});

//     const [activeTab, setActiveTab] = useState("OKR Tracker");

//     /* ---------- FINANCIAL YEAR & QUARTER LOGIC ---------- */
//     const today = new Date();
//     const currentMonth = today.getMonth() + 1;

//     const getFY = (date) => {
//         const m = date.getMonth() + 1;
//         const y = date.getFullYear();
//         return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//     };

//     const getCurrentQuarterLimit = (month) => {
//         if (month >= 4 && month <= 6) return 'Quarter 1';
//         if (month >= 7 && month <= 9) return 'Quarter 2';
//         if (month >= 10 && month <= 12) return 'Quarter 3';
//         return 'Quarter 4';
//     };

//     const [userData, setUserData] = useState(null);
//     const [isSyncing, setIsSyncing] = useState(false);
//     const [isTimelineLockedFromDB, setIsTimelineLockedFromDB] = useState(false);
//     const [selectedYear, setSelectedYear] = useState(getFY(today));
//     const [selectedQuarter, setSelectedQuarter] = useState("");

//     const [history, setHistory] = useState([]);
//     const [workflowStep, setWorkflowStep] = useState('Planning');
//     const [showModal, setShowModal] = useState(false);
//     const [modalMsg, setModalMsg] = useState('');

//     /* ---------- EMPLOYEE REVIEW STATE ---------- */
//     const [reviewData, setReviewData] = useState({
//         review_period: '',
//         job_title: '',
//         achievements: Array(5).fill(''),
//         responsibilities: Array(5).fill(''),
//         skills_growth: Array(5).fill(''),
//         challenges: Array(5).fill(''),
//         improvement_areas: Array(5).fill(''),
//         goals_next_year: Array(5).fill(''),
//         additional_contributions: Array(5).fill(''),
//         support_needed: Array(5).fill('')
//     });

//     const [okrRows, setOkrRows] = useState([
//         {
//             id: Date.now(),
//             objective: '',
//             keyResults: Array.from({ length: 6 }, () => ({ text: '', result: 'Pending' }))
//         }
//     ]);

//     const resultOptions = ['Pending', 'Not Met/ Downgraded', 'Successfull', 'Exceeds', 'Excellence'];
//     const quarterOptions = ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'];
//     const yearOptions = ["2024-2025", "2025-2026", "2026-2027"];

//     /* ---------- AUTO-RESIZE LOGIC ---------- */
//     const autoResize = (target) => {
//         if (target) {
//             target.style.height = 'auto';
//             target.style.height = `${target.scrollHeight}px`;
//         }
//     };

//     // Re-run resize when tabs change or data loads
//     useEffect(() => {
//         const textareas = document.querySelectorAll('.obj-textarea, .kr-single-textarea, .doc-point-textarea');
//         textareas.forEach(el => autoResize(el));
//     }, [okrRows, activeTab, reviewData]);

//     useEffect(() => {
//         if (propUserData) {
//             setUserData({
//                 EmpId: propUserData.EmpId || propUserData.id,
//                 DisplayName: `${propUserData.firstName || ''} ${propUserData.lastName || ''}`.trim(),
//                 Department: propUserData.Department || ''
//             });
//         }
//     }, [propUserData]);



//     useEffect(() => {
//         const fetchAllLocks = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/get_timeline_lock.php?year=${selectedYear}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 if (data.success && data.data) {
//                     const lockMap = {};
//                     data.data.forEach(item => {
//                         lockMap[item.quarter] = item.locked == 1;
//                     });
//                     setLockedQuarters(lockMap);
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         if (selectedYear) fetchAllLocks();
//     }, [selectedYear]);

//     const loadExistingOKR = useCallback(async (year, quarter, force = false) => {
//         if (!userData?.EmpId || !year || !quarter) return;

//         try {
//             const res = await fetch(
//                 `/gt-api/get_user_okr.php?empId=${userData.EmpId}&year=${year}&quarter=${quarter}`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await res.json();

//             if (data.success) {

//                 // ✅ DEEP CLONE (VERY IMPORTANT)
//                 const parsedRaw =
//                     typeof data.data === 'string'
//                         ? JSON.parse(data.data)
//                         : data.data;

//                 const parsed = JSON.parse(JSON.stringify(parsedRaw));

//                 // ✅ CLEAN + REBUILD DATA
//                 const cleanedData = parsed.map((obj) => {
//                     return {
//                         ...obj,
//                         id: obj.id || `${Date.now()}-${Math.random()}`, // 🔥 ensure unique objective id
//                         keyResults: Array.from({ length: 6 }, (_, i) => {
//                             const kr = obj.keyResults?.[i] || {};

//                             const newKR = {
//                                 text: kr.text ? String(kr.text) : '',
//                                 result: kr.result ? String(kr.result) : 'Pending',
//                                 ar_comment: kr.ar_comment ? String(kr.ar_comment) : '',
//                                 _krId: `${i}-${Date.now()}-${Math.random()}` // 🔥 UNIQUE PER KR
//                             };

//                             if (
//                                 data.workflow_status === 'Scoring' ||
//                                 data.workflow_status === 'Sign_Off' ||
//                                 data.workflow_status === 'Locked'
//                             ) {
//                                 delete newKR.ar_comment;
//                             }

//                             return { ...newKR }; // 🔥 force new object
//                         })
//                     };
//                 });

//                 setOkrRows(cleanedData);
//                 setWorkflowStep(data.workflow_status);

//             } else if (force || !data.success) {

//                 setWorkflowStep('Planning');

//                 setOkrRows([
//                     {
//                         id: Date.now(),
//                         objective: '',
//                         keyResults: Array.from({ length: 6 }, () => ({
//                             text: '',
//                             result: 'Pending'
//                         }))
//                     }
//                 ]);
//             }

//         } catch (err) {
//             console.error(err);
//         }
//     }, [userData]);

//     useEffect(() => {
//         if (selectedQuarter) {
//             loadExistingOKR(selectedYear, selectedQuarter);
//         }
//     }, [selectedYear, selectedQuarter, loadExistingOKR]);

//     useEffect(() => {
//         const fetchLock = async () => {
//             try {
//                 const res = await fetch(
//     `/gt-api/get_timeline_lock.php?year=${selectedYear}&quarter=${selectedQuarter}`,
//     {
//         credentials: "include"
//     }
// );
//                 const data = await res.json();
//                 console.log("CHECK LOCK API:", selectedYear, selectedQuarter);

//                 if (data.success) {
//                     setIsTimelineLockedFromDB(data.locked === true || data.locked === "true" || data.locked == 1);
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         if (selectedYear && selectedQuarter) {
//             fetchLock();
//         }
//     }, [selectedYear, selectedQuarter]);

//     const fetchHistory = useCallback(async () => {
//         if (!userData?.EmpId) return;
//         try {
//             const res = await fetch(
//   `/gt-api/get_okr_history.php?empId=${userData.EmpId}`,
//   {
//     credentials: "include"
//   }
// );
//             const data = await res.json();
//             setHistory(data || []);
//         } catch (err) { console.error(err); }
//     }, [userData]);

//     useEffect(() => {
//         fetchHistory();
//     }, [fetchHistory]);

//     useEffect(() => {
//         if (defaultTab) {
//             setActiveTab(defaultTab);
//         }
//     }, [defaultTab]);

//     const getQuarterStatusLabel = (q) => {
//         const record = history.find(h => h.quarter === q && h.year.toString() === selectedYear.toString());
//         if (!record) return "";
//         const status = record.workflow_status;
//         if (status === 'Locked' || status === 'Sign_Off') return " (Locked)";
//         return ` (${status.replace(/_/g, ' ')})`;
//     };

//     const handleInputChange = (id, field, value, krIndex = null) => {
//         setOkrRows(prev => prev.map(row => {
//             if (row.id !== id) return row;
//             if (krIndex !== null) {
//                 const krs = [...row.keyResults];
//                 krs[krIndex] = { ...krs[krIndex], [field]: value };
//                 return { ...row, keyResults: krs };
//             }
//             return { ...row, [field]: value };
//         }));
//     };

//     const handleReviewChange = (sectionId, index, value) => {
//         setReviewData(prev => {
//             const updatedSection = [...prev[sectionId]];
//             updatedSection[index] = value;
//             return { ...prev, [sectionId]: updatedSection };
//         });
//     };

//     const addNewObjective = () => {
//         if (okrRows.length >= 6) return;
//         setOkrRows(prev => [...prev, {
//             id: Date.now(),
//             objective: '',
//             keyResults: Array.from({ length: 6 }, () => ({ text: '', result: 'Pending' }))
//         }]);
//     };

//     const deleteObjective = (id) => {
//         if (okrRows.length === 1) return;
//         setOkrRows(prev => prev.filter(o => o.id !== id));
//     };

//     const [managementNotices, setManagementNotices] = useState({ reviews: [], probations: [] });

//     const fetchNotices = useCallback(async () => {
//         if (!userData?.EmpId) return;
//         try {
//           const res = await fetch(
//   `/gt-api/get_manager_feedback.php?empId=${userData.EmpId}`,
//   {
//     credentials: "include"
//   }
// );
//             const data = await res.json();
//             if (data.success) {
//                 setManagementNotices({
//                     reviews: data.reviews || [],
//                     probations: data.probations || []
//                 });
//             }
//         } catch (err) { console.error(err); }
//     }, [userData]);

//     useEffect(() => {
//         if (activeTab === "Manager Review") {
//             fetchNotices();
//             localStorage.setItem("seen_reviews", new Date().toISOString());
//         }

//         if (activeTab === "Probation Period Feedback") {
//             fetchNotices();
//             localStorage.setItem("seen_probation", new Date().toISOString());
//         }
//     }, [activeTab, fetchNotices]);

//     const handleViewFromLog = (year, quarter) => {
//         setSelectedYear(year);
//         setSelectedQuarter(quarter);
//         loadExistingOKR(year, quarter, true);
//         setActiveTab("OKR Tracker");
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//     };

//     const syncToGenesis = async () => {
//         if (!selectedYear || !selectedQuarter) {
//             alert("Please select a quarter first.");
//             return;
//         }

//         if (
//             isTimelineLockedFromDB &&
//             workflowStep !== 'Returned_To_Employee' &&
//             workflowStep !== 'Scoring'
//         ) {
//             alert("This quarter is locked.");
//             return;
//         }

//         setIsSyncing(true);

//         try {
//             const res = await fetch('/gt-api/submit_okr.php', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 credentials: "include",
//                 body: JSON.stringify({
//                     empId: userData.EmpId,
//                     empName: userData.DisplayName,
//                     department: userData.Department,
//                     year: selectedYear,
//                     quarter: selectedQuarter,
//                     okrData: okrRows,
//                     status:
//                         workflowStep === 'Planning' || workflowStep === 'Returned_To_Employee'
//                             ? 'Management_Review'
//                             : 'Manager_Scoring_Review'
//                 })
//             });

//             const text = await res.text();
//             console.log("RAW RESPONSE:", text);

//             let data;
//             try {
//                 data = JSON.parse(text);
//             } catch {
//                 // 🔥 even if JSON fails → assume success (since DB saved)
//                 setModalMsg("Saved successfully!");
//                 setShowModal(true);
//                 fetchHistory();
//                 return;
//             }

//             // ✅ flexible success handling
//             if (data.success || data.status === "ok") {
//                 setModalMsg("Saved successfully!");
//                 setShowModal(true);
//                 fetchHistory();
//             } else {
//                 alert("Something went wrong: " + (data.message || text));
//             }

//         } catch (err) {
//             console.error(err);
//             alert("Network error. Failed to save.");
//         } finally {
//             setIsSyncing(false);
//         }
//     };


//     const submitSelfReview = async (e) => {
//         e.preventDefault();
//         setIsSyncing(true);
//         try {
//             const res = await fetch('/gt-api/submit_employee_review.php', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 credentials: "include",
//                 body: JSON.stringify({
//                     empid: userData.EmpId,
//                     full_name: userData.DisplayName,
//                     team: userData.Department,
//                     job_title: reviewData.job_title,
//                     review_period: reviewData.review_period,
//                     achievements: reviewData.achievements,
//                     responsibilities: reviewData.responsibilities,
//                     skills_growth: reviewData.skills_growth,
//                     challenges: reviewData.challenges,
//                     improvement_areas: reviewData.improvement_areas,
//                     goals_next_year: reviewData.goals_next_year,
//                     additional_contributions: reviewData.additional_contributions,
//                     support_needed: reviewData.support_needed
//                 })
//             });
//             const data = await res.json();

//             if (data.success) {
//                 setModalMsg("Your self-review has been submitted successfully!");
//                 setShowModal(true);
//             } else {
//                 alert("Failed to submit review: " + data.message);
//             }
//         } catch { alert("Network error. Failed to submit review."); } finally { setIsSyncing(false); }
//     };

//     const canEditOKR =
//         (
//             (!isTimelineLockedFromDB && workflowStep === 'Planning') ||
//             workflowStep === 'Returned_To_Employee'
//         ) &&
//         selectedQuarter !== "";

//     const canScore =
//         workflowStep === 'Scoring' &&
//         (workflowStep === 'Scoring') &&
//         selectedQuarter !== "";
//     const updateProgress = async () => {
//         if (!selectedYear || !selectedQuarter) return;

//         setIsSyncing(true);

//         try {
//             const res = await fetch('/gt-api/update_okr_progress.php', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 credentials: "include",
//                 body: JSON.stringify({
//                     empId: userData.EmpId,
//                     year: selectedYear,
//                     quarter: selectedQuarter,
//                     okrData: okrRows
//                 })
//             });

//             const data = await res.json();

//             console.log("SERVER RESPONSE:", data);

//             if (data.success) {
//                 setModalMsg("Progress updated successfully!");
//                 setShowModal(true);

//                 // ❌ old (keep or remove, doesn't matter)
//                 localStorage.setItem("okr_updated", Date.now());

//                 // ✅ ADD THIS (THIS IS THE REAL FIX)
//                 window.dispatchEvent(new Event("okrUpdated"));
//             }
//         } catch (err) {
//             console.error(err);
//             alert("Network error");
//         } finally {
//             setIsSyncing(false);
//         }
//     };
//     const isEmployeeTurn = ['Planning', 'Scoring', 'Returned_To_Employee'].includes(workflowStep);

//     const isLocked = workflowStep === 'Locked' || workflowStep === 'Sign_Off';



//     const renderSubModule = () => {
//         switch (activeTab) {
//             case "OKR Tracker":
//                 return (
//                     <div className="okr-genesis-container">
//                         {showModal && (
//                             <div className="okrmodaloverlay" style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'fixed', inset: 0, zIndex: 1000 }}>
//                                 <div className="okr-success-modal animate-pop" style={{ backgroundColor: '#ffffff', padding: '40px', borderRadius: '16px', textAlign: 'center', maxWidth: '400px', width: '90%', boxShadow: '0 20px 40px rgba(0,0,0,0.2)' }}>
//                                     <div className="success-icon-container" style={{ backgroundColor: '#e8f5e9', width: '60px', height: '60px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
//                                         <div className="check-mark" style={{ color: '#2e7d32', fontSize: '30px', fontWeight: 'bold' }}>✓</div>
//                                     </div>
//                                     <h2 style={{ color: '#1a1a1a', marginBottom: '10px', fontSize: '1.5rem' }}>All Set!</h2>
//                                     <p style={{ color: '#666666', marginBottom: '30px', lineHeight: '1.5' }}>{modalMsg}</p>
//                                     <button className="btn-modal-continue" onClick={() => window.location.reload()} style={{ backgroundColor: '#2196F3', color: '#ffffff', border: 'none', padding: '12px 30px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', width: '100%' }}>CONTINUE</button>
//                                 </div>
//                             </div>
//                         )}

//                         <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
//                             <div className="okr-glass-card" style={{ width: '100%' }}>
//                                 <header className="okr-view-header">
//                                     <div className="title-group">
//                                         <div className="status-badge"><span className="pulse-ring"></span></div>
//                                         <h1>OKR <span className="blue-gradient-text">Tracker</span></h1>
//                                     </div>
//                                     <div className="header-actions">
//                                         <select className="time-select-modern" value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
//                                             {yearOptions.map(y => <option key={y} value={y}>{y}</option>)}
//                                         </select>

//                                         <select
//                                             className="time-select-modern"
//                                             value={selectedQuarter}
//                                             onChange={(e) => setSelectedQuarter(e.target.value)}
//                                         >
//                                             <option value="" disabled>Select Quarter</option>

//                                             {quarterOptions.map(q => {
//                                                 const currentQuarter = getCurrentQuarterLimit(currentMonth);
//                                                 const isCurrentYear = selectedYear === getFY(today);

//                                                 const isFutureQuarter =
//                                                     isCurrentYear &&
//                                                     quarterOptions.indexOf(q) > quarterOptions.indexOf(currentQuarter);

//                                                 // 🔥 USE EXISTING STATE (NO NEW API)
//                                                 const isLockedFromDB =
//                                                     selectedQuarter === q && isTimelineLockedFromDB;

//                                                 const isDisabled = isFutureQuarter || isLockedFromDB;

//                                                 return (
//                                                     <option key={q} value={q} disabled={isDisabled}>
//                                                         {q} {isLockedFromDB ? "🔒 Locked" : ""}
//                                                     </option>
//                                                 );
//                                             })}
//                                         </select>

//                                         <span className="node-count">
//                                             {userData ? `${userData.DisplayName.toUpperCase()} | ${isLocked ? 'LOCKED' : workflowStep.replace(/_/g, ' ')}` : "CONNECTING..."}
//                                         </span>
//                                     </div>
//                                 </header>

//                                 <div className="okr-table-wrapper">
//                                     <table className="okr-modern-table">
//                                         <thead>
//                                             <tr><th width="35%">Goal Objective</th><th width="45%">Key Results (6)</th><th width="20%">Status</th></tr>
//                                         </thead>
//                                         <tbody>
//                                             {okrRows.map((row, rowIdx) => (
//                                                 <React.Fragment key={row.id}>
//                                                     {row.keyResults.map((kr, idx) => (
//                                                         <tr
//                                                             key={kr._krId || `${row.id}-${idx}`}
//                                                             className={`data-row ${idx === row.keyResults.length - 1 ? 'block-end' : ''}`}
//                                                         >
//                                                             {idx === 0 && (
//                                                                 <td rowSpan={row.keyResults.length} className="objective-spanned-cell">
//                                                                     <div className="obj-header-row">
//                                                                         <div className="obj-number">
//                                                                             Goal {rowIdx + 1}
//                                                                         </div>

//                                                                         {(
//                                                                             (workflowStep === 'Returned_To_Employee') ||
//                                                                             !isTimelineLockedFromDB
//                                                                         ) && canEditOKR && okrRows.length > 1 && (
//                                                                                 <button
//                                                                                     className="btn-delete-obj"
//                                                                                     onClick={() => deleteObjective(row.id)}
//                                                                                 >
//                                                                                     ✕
//                                                                                 </button>
//                                                                             )}
//                                                                     </div>

//                                                                     <textarea
//                                                                         className="obj-textarea"
//                                                                         placeholder={
//                                                                             selectedQuarter
//                                                                                 ? "What is your main focus?..."
//                                                                                 : "Select a quarter to begin..."
//                                                                         }
//                                                                         value={row.objective}
//                                                                         disabled={!canEditOKR}
//                                                                         onChange={(e) => {
//                                                                             handleInputChange(row.id, 'objective', e.target.value);
//                                                                             autoResize(e.target);
//                                                                         }}
//                                                                     />
//                                                                 </td>
//                                                             )}

//                                                             <td className="kr-cell">
//                                                                 <div className="kr-input-wrapper">
//                                                                     <span className="kr-index">
//                                                                         0{idx + 1}
//                                                                     </span>

//                                                                     <textarea
//                                                                         className="kr-single-textarea"
//                                                                         placeholder="Key measure..."
//                                                                         value={kr.text}
//                                                                         disabled={!canEditOKR}
//                                                                         onChange={(e) => {
//                                                                             handleInputChange(row.id, 'text', e.target.value, idx);
//                                                                             autoResize(e.target);
//                                                                         }}
//                                                                     />
//                                                                 </div>

//                                                                 {kr.ar_comment && (
//                                                                     <div
//                                                                         style={{
//                                                                             marginTop: '6px',
//                                                                             padding: '8px',
//                                                                             borderRadius: '6px',
//                                                                             background: 'rgba(255,152,0,0.08)',
//                                                                             borderLeft: '3px solid #ff9800',
//                                                                             fontSize: '12px',
//                                                                         }}
//                                                                     >
//                                                                         <strong>AR:</strong> {kr.ar_comment}
//                                                                     </div>
//                                                                 )}
//                                                             </td>

//                                                             <td>
//                                                                 <select
//                                                                     className="modern-select"
//                                                                     value={kr.result}
//                                                                     disabled={!canScore}
//                                                                     onChange={(e) =>
//                                                                         handleInputChange(row.id, 'result', e.target.value, idx)
//                                                                     }
//                                                                 >
//                                                                     {resultOptions.map((opt) => (
//                                                                         <option key={opt} value={opt}>
//                                                                             {opt}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             </td>
//                                                         </tr>
//                                                     ))}
//                                                 </React.Fragment>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>

//                                 <footer className="okr-footer">
//                                     <div className="footer-left">
//                                         {((workflowStep === 'Returned_To_Employee') || !isTimelineLockedFromDB) && canEditOKR && okrRows.length < 6 && (
//                                             <button className="btn-add-objective" onClick={addNewObjective}>+ Add another Goal ({okrRows.length}/6)</button>
//                                         )}
//                                     </div>
//                                     <div className="footer-right">

//                                         {/* 🔥 NEW BUTTON */}
//                                         {canScore && !isLocked && (
//                                             <button
//                                                 className="btn-secondary"
//                                                 onClick={updateProgress}
//                                                 disabled={isSyncing}
//                                             >
//                                                 {isSyncing ? "Updating..." : "Update Progress"}
//                                             </button>
//                                         )}

//                                         {/* EXISTING BUTTON */}
//                                         {selectedQuarter &&
//                                             isEmployeeTurn &&
//                                             !isLocked &&
//                                             (
//                                                 workflowStep === 'Returned_To_Employee' ||
//                                                 workflowStep === 'Scoring' ||
//                                                 !isTimelineLockedFromDB
//                                             ) && (
//                                                 <button className="btn-primary" onClick={syncToGenesis} disabled={isSyncing}>
//                                                     {isSyncing
//                                                         ? "Saving..."
//                                                         : workflowStep === 'Returned_To_Employee'
//                                                             ? "Resubmit"
//                                                             : workflowStep === 'Planning'
//                                                                 ? "Send for Review"
//                                                                 : "Submit"}
//                                                 </button>
//                                             )}

//                                     </div>
//                                 </footer>
//                             </div>

//                             <div className="okr-glass-card" style={{ width: '100%', padding: '20px' }}>
//                                 <h3 className="blue-gradient-text" style={{ fontSize: '1.1rem', marginBottom: '15px' }}>MY HISTORY</h3>
//                                 <div className="okr-table-wrapper">
//                                     {isTimelineLockedFromDB && (
//                                         <div style={{
//                                             background: "#ff4d4f",
//                                             color: "#fff",
//                                             padding: "10px",
//                                             borderRadius: "6px",
//                                             textAlign: "center",
//                                             fontWeight: "600",
//                                             marginBottom: "10px"
//                                         }}>
//                                             🔒 This quarter is locked by management
//                                         </div>
//                                     )}
//                                     <table className="okr-modern-table">
//                                         <thead>
//                                             <tr><th>Period</th><th>Submitted On</th><th>Status</th><th style={{ textAlign: 'right' }}>Action</th></tr>
//                                         </thead>
//                                         <tbody>
//                                             {history.map((item) => (
//                                                 <tr key={item.id} className="data-row">
//                                                     <td style={{ fontWeight: '600' }}>{item.quarter} {item.year}</td>
//                                                     <td style={{ opacity: 0.6 }}>{new Date(item.submitted_at).toLocaleDateString()}</td>
//                                                     <td>
//                                                         <span className="status-pill-mini">
//                                                             {item.workflow_status === 'Locked' || item.workflow_status === 'Sign_Off' ? '🔒 Locked' : item.workflow_status.replace(/_/g, ' ')}
//                                                         </span>
//                                                     </td>
//                                                     <td style={{ textAlign: 'right' }}>
//                                                         <button className="btn-view-data" onClick={() => handleViewFromLog(item.year, item.quarter)}>VIEW DATA</button>
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>


//                             </div>
//                         </div>
//                     </div>
//                 );




//             case "Employee Self Performance Review":
//                 return (
//                     <div className="okr-genesis-container animate-fade">
//                         {showModal && (
//                             <div className="modal-overlay" style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'fixed', inset: 0, zIndex: 1000, backdropFilter: 'blur(10px)' }}>
//                                 <div className="okr-success-modal animate-pop" style={{ background: '#111', border: '1px solid #00bcd4', padding: '40px', borderRadius: '20px', textAlign: 'center', maxWidth: '400px', width: '90%' }}>
//                                     <div style={{ fontSize: '40px', marginBottom: '15px' }}>📋</div>
//                                     <h2 className="blue-gradient-text">Review Submitted</h2>
//                                     <p style={{ color: 'rgba(255,255,255,0.7)', marginBottom: '25px' }}>{modalMsg}</p>
//                                     <button className="btn-modal-continue" onClick={() => window.location.reload()} style={{ background: '#00bcd4', color: '#000', border: 'none', padding: '12px 25px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>OK</button>
//                                 </div>
//                             </div>
//                         )}

//                         <div className="review-document-container" style={{ maxWidth: '950px', margin: '0 auto', paddingBottom: '50px' }}>
//                             <div className="review-doc-paper" style={{ background: 'rgba(255, 255, 255, 0.03)', backdropFilter: 'blur(20px)', border: '1px solid rgba(255, 255, 255, 0.1)', borderRadius: '12px', padding: '50px' }}>

//                                 <div className="doc-header-grid" style={{ display: 'flex', gap: '40px', borderBottom: '2px solid #00bcd4', paddingBottom: '30px', marginBottom: '40px' }}>
//                                     <div className="doc-logo-section">
//                                         <img src={logoImg} alt="Logo" style={{ maxWidth: '140px', height: 'auto', filter: 'brightness(1.2)' }} />
//                                     </div>
//                                     <div className="doc-title-section">
//                                         <h1 style={{ fontSize: '2.2rem', fontWeight: '800', margin: '0 0 10px 0', color: '#fff' }}>Employee Annual Self-Review Form</h1>
//                                         <p style={{ fontSize: '0.95rem', lineHeight: '1.6', opacity: 0.7, color: '#fff' }}>
//                                             Please complete this self-review to reflect on your performance. <strong>Provide 5 points for each section.</strong>
//                                         </p>
//                                     </div>
//                                 </div>

//                                 <form onSubmit={submitSelfReview}>
//                                     <div className="doc-section" style={{ marginBottom: '40px' }}>
//                                         <h3 style={{ color: '#00bcd4', textTransform: 'uppercase', fontSize: '0.85rem', letterSpacing: '2px', marginBottom: '20px' }}>SECTION 1 — Basic Information</h3>
//                                         <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
//                                             <div className="doc-field">
//                                                 <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.6, marginBottom: '5px', color: '#fff' }}>1. Full Name:</label>
//                                                 <input type="text" className="doc-underlined-input" value={userData?.DisplayName} readOnly />
//                                             </div>
//                                             <div className="doc-field">
//                                                 <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.6, marginBottom: '5px', color: '#fff' }}>2. Job Title:</label>
//                                                 <input type="text" className="doc-underlined-input" placeholder="Your Title..." onChange={(e) => setReviewData({ ...reviewData, job_title: e.target.value })} />
//                                             </div>
//                                             <div className="doc-field">
//                                                 <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.6, marginBottom: '5px', color: '#fff' }}>3. Team:</label>
//                                                 <input type="text" className="doc-underlined-input" value={userData?.Department} readOnly />
//                                             </div>
//                                             <div className="doc-field">
//                                                 <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.6, marginBottom: '5px', color: '#fff' }}>4. Review Period:</label>
//                                                 <input type="text" className="doc-underlined-input" placeholder="Jan 2025 – Dec 2025" required onChange={(e) => setReviewData({ ...reviewData, review_period: e.target.value })} />
//                                             </div>
//                                         </div>
//                                     </div>

//                                     {[
//                                         { id: 'achievements', title: 'SECTION 2 — Key Achievements', instruction: 'List your top achievements this year:' },
//                                         { id: 'responsibilities', title: 'SECTION 3 — Role & Responsibilities', instruction: 'Describe your main responsibilities and any additional tasks:' },
//                                         { id: 'skills_growth', title: 'SECTION 4 — Skills & Growth', instruction: 'What new skills or knowledge did you acquire?' },
//                                         { id: 'challenges', title: 'SECTION 5 — Challenges', instruction: 'What challenges did you face and how did you handle them?' },
//                                         { id: 'improvement_areas', title: 'SECTION 6 — Improvement Areas', instruction: 'What areas do you want to improve next year?' },
//                                         { id: 'goals_next_year', title: 'SECTION 7 — Goals for Next Year', instruction: 'List goals you want to work on next year:' },
//                                         { id: 'additional_contributions', title: 'SECTION 8 — Additional Contributions', instruction: 'Mention team support, mentoring, or other initiatives:' },
//                                         { id: 'support_needed', title: 'SECTION 9 — Support Needed', instruction: 'What resources do you need from your manager?' }
//                                     ].map((section) => (
//                                         <div className="doc-section" key={section.id} style={{ marginBottom: '35px' }}>
//                                             <h3 style={{ color: '#00bcd4', textTransform: 'uppercase', fontSize: '0.85rem', letterSpacing: '2px', marginBottom: '10px' }}>{section.title}</h3>
//                                             <p style={{ fontSize: '0.9rem', marginBottom: '15px', fontWeight: '500', color: '#fff' }}>{section.instruction}</p>

//                                             <div className="five-point-container" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
//                                                 {[0, 1, 2, 3, 4].map((idx) => (
//                                                     <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: '15px', background: 'rgba(255,255,255,0.02)', padding: '10px 15px', borderRadius: '4px' }}>
//                                                         <span style={{ fontSize: '0.8rem', opacity: 0.4, color: '#00bcd4', fontWeight: 'bold', marginTop: '4px' }}>{idx + 1}.</span>
//                                                         <textarea
//                                                             placeholder="..."
//                                                             className="doc-point-textarea"
//                                                             rows="1"
//                                                             value={reviewData[section.id][idx]}
//                                                             onChange={(e) => {
//                                                                 handleReviewChange(section.id, idx, e.target.value);
//                                                                 autoResize(e.target);
//                                                             }}
//                                                             style={{
//                                                                 width: '100%',
//                                                                 background: 'transparent',
//                                                                 border: 'none',
//                                                                 color: '#fff',
//                                                                 outline: 'none',
//                                                                 resize: 'none',
//                                                                 overflow: 'hidden',
//                                                                 padding: '0',
//                                                                 lineHeight: '1.5'
//                                                             }}
//                                                         />
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         </div>
//                                     ))}

//                                     <div style={{ textAlign: 'center', marginTop: '50px' }}>
//                                         <button type="submit" className="doc-submit-btn" disabled={isSyncing} style={{ background: '#00bcd4', color: '#000', border: 'none', padding: '18px 60px', borderRadius: '4px', fontWeight: '800', cursor: 'pointer', transition: '0.3s' }}>
//                                             {isSyncing ? "SAVING DATA..." : "SUBMIT COMPLETED REVIEW"}
//                                         </button>
//                                     </div>
//                                 </form>
//                             </div>
//                         </div>
//                     </div>
//                 );

//             case "Manager Review":
//                 return (
//                     <div className="okr-genesis-container animate-fade">
//                         <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
//                             <h2 className="blue-gradient-text">Manager Review</h2>
//                             {managementNotices.reviews.length > 0 ? (
//                                 managementNotices.reviews.map((item, index) => (
//                                     <div key={index} className="okr-glass-card" style={{ padding: '20px', borderLeft: '4px solid #00bcd4' }}>
//                                         <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', opacity: 0.6, fontSize: '0.8rem' }}>
//                                             <span>OFFICIAL REVIEW</span>
//                                             <span>{new Date(item.created_at).toLocaleDateString()}</span>
//                                         </div>
//                                         <div style={{ color: '#fff', whiteSpace: 'pre-wrap', lineHeight: '1.6' }}>{item.content}</div>
//                                     </div>
//                                 ))
//                             ) : (
//                                 <div className="okr-glass-card" style={{ padding: '20px', textAlign: 'center', opacity: 0.5 }}>No reviews found.</div>
//                             )}
//                         </div>
//                     </div>
//                 );

//             case "Probation Period Feedback":
//                 return (
//                     <div className="okr-genesis-container animate-fade">
//                         <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
//                             <h2 className="blue-gradient-text">Probation Notice</h2>
//                             {managementNotices.probations.length > 0 ? (
//                                 managementNotices.probations.map((item, index) => (
//                                     <div key={index} className="okr-glass-card" style={{ padding: '20px', borderLeft: '4px solid #ff5252' }}>
//                                         <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', opacity: 0.6, fontSize: '0.8rem' }}>
//                                             <span>NOTICE OF PROBATION</span>
//                                             <span>{new Date(item.created_at).toLocaleDateString()}</span>
//                                         </div>
//                                         <div style={{ color: '#fff', whiteSpace: 'pre-wrap', lineHeight: '1.6' }}>{item.content}</div>
//                                     </div>
//                                 ))
//                             ) : (
//                                 <div className="okr-glass-card" style={{ padding: '20px', textAlign: 'center', opacity: 0.5 }}>No probation notices found.</div>
//                             )}
//                         </div>
//                     </div>
//                 );



//             default: return null;
//         }
//     };

//     return (
//         <div className="pay-module">
//             <div className="pay-nav-grid">
//                 {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//                     <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => setActiveTab(tab)}>
//                         {tab.toUpperCase()}
//                     </button>
//                 ))}
//             </div>
//             <div className="pay-content-area">
//                 {renderSubModule()}
//             </div>
//         </div>
//     );
// };

// export default OKRTracker;

























// import React, { useState, useEffect, useCallback } from 'react';
// import { createPortal } from 'react-dom';
// import logoImg from '../assets/logo.jpg';
// import '../styles/OKRTracker.css';

// const OKRTracker = ({ userData: propUserData, defaultTab }) => {

//     const [lockedQuarters, setLockedQuarters] = useState({});

//     const [activeTab, setActiveTab] = useState("OKR Tracker");

//     /* ---------- FINANCIAL YEAR & QUARTER LOGIC ---------- */
//     const today = new Date();
//     const currentMonth = today.getMonth() + 1;

//     const getFY = (date) => {
//         const m = date.getMonth() + 1;
//         const y = date.getFullYear();
//         return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//     };

//     const getCurrentQuarterLimit = (month) => {
//         if (month >= 4 && month <= 6) return 'Quarter 1';
//         if (month >= 7 && month <= 9) return 'Quarter 2';
//         if (month >= 10 && month <= 12) return 'Quarter 3';
//         return 'Quarter 4';
//     };

//     const [userData, setUserData] = useState(null);
//     const [isSyncing, setIsSyncing] = useState(false);
//     const [isTimelineLockedFromDB, setIsTimelineLockedFromDB] = useState(false);
//     const [selectedYear, setSelectedYear] = useState(getFY(today));
//     const [selectedQuarter, setSelectedQuarter] = useState("");

//     const [history, setHistory] = useState([]);
//     const [workflowStep, setWorkflowStep] = useState('Planning');
//     const [showModal, setShowModal] = useState(false);
//     const [modalMsg, setModalMsg] = useState('');

//     /* ---------- EMPLOYEE REVIEW STATE ---------- */
//     const [reviewData, setReviewData] = useState({
//         review_period: '',
//         job_title: '',
//         achievements: Array(5).fill(''),
//         responsibilities: Array(5).fill(''),
//         skills_growth: Array(5).fill(''),
//         challenges: Array(5).fill(''),
//         improvement_areas: Array(5).fill(''),
//         goals_next_year: Array(5).fill(''),
//         additional_contributions: Array(5).fill(''),
//         support_needed: Array(5).fill('')
//     });

//     const [okrRows, setOkrRows] = useState([
//         {
//             id: Date.now(),
//             objective: '',
//             keyResults: Array.from({ length: 6 }, () => ({ text: '', result: 'Pending' }))
//         }
//     ]);

//     const resultOptions = ['Pending', 'Not Met/ Downgraded', 'Successfull', 'Exceeds', 'Excellence'];
//     const quarterOptions = ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'];
//     const yearOptions = ["2024-2025", "2025-2026", "2026-2027"];

//     /* ---------- AUTO-RESIZE LOGIC ---------- */
//     const autoResize = (target) => {
//         if (target) {
//             target.style.height = 'auto';
//             target.style.height = `${target.scrollHeight}px`;
//         }
//     };

//     // Re-run resize when tabs change or data loads
//     useEffect(() => {
//         const textareas = document.querySelectorAll('.obj-textarea, .kr-single-textarea, .doc-point-textarea');
//         textareas.forEach(el => autoResize(el));
//     }, [okrRows, activeTab, reviewData]);

//     useEffect(() => {
//         if (propUserData) {
//             setUserData({
//                 EmpId: propUserData.EmpId || propUserData.id,
//                 DisplayName: `${propUserData.firstName || ''} ${propUserData.lastName || ''}`.trim(),
//                 Department: propUserData.Department || ''
//             });
//         }
//     }, [propUserData]);





//     useEffect(() => {
//         const fetchAllLocks = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/get_timeline_lock.php?year=${selectedYear}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 if (data.success && data.data) {
//                     const lockMap = {};
//                     data.data.forEach(item => {
//                         lockMap[item.quarter] = item.locked == 1;
//                     });
//                     setLockedQuarters(lockMap);
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         if (selectedYear) fetchAllLocks();
//     }, [selectedYear]);

//     const loadExistingOKR = useCallback(async (year, quarter, force = false) => {
//         if (!userData?.EmpId || !year || !quarter) return;

//         try {
//             const res = await fetch(
//                 `/gt-api/get_user_okr.php?empId=${userData.EmpId}&year=${year}&quarter=${quarter}`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await res.json();

//             if (data.success) {

//                 // ✅ DEEP CLONE (VERY IMPORTANT)
//                 const parsedRaw =
//                     typeof data.data === 'string'
//                         ? JSON.parse(data.data)
//                         : data.data;

//                 const parsed = JSON.parse(JSON.stringify(parsedRaw));

//                 // ✅ CLEAN + REBUILD DATA
//                 const cleanedData = parsed.map((obj) => {
//                     return {
//                         ...obj,
//                         id: obj.id || `${Date.now()}-${Math.random()}`, // 🔥 ensure unique objective id
//                         keyResults: Array.from({ length: 6 }, (_, i) => {
//                             const kr = obj.keyResults?.[i] || {};

//                             const newKR = {
//                                 text: kr.text ? String(kr.text) : '',
//                                 result: kr.result ? String(kr.result) : 'Pending',
//                                 ar_comment: kr.ar_comment ? String(kr.ar_comment) : '',
//                                 _krId: `${i}-${Date.now()}-${Math.random()}` // 🔥 UNIQUE PER KR
//                             };

//                             if (
//                                 data.workflow_status === 'Scoring' ||
//                                 data.workflow_status === 'Sign_Off' ||
//                                 data.workflow_status === 'Locked'
//                             ) {
//                                 delete newKR.ar_comment;
//                             }

//                             return { ...newKR }; // 🔥 force new object
//                         })
//                     };
//                 });

//                 setOkrRows(cleanedData);
//                 setWorkflowStep(data.workflow_status);

//             } else if (force || !data.success) {

//                 setWorkflowStep('Planning');

//                 setOkrRows([
//                     {
//                         id: Date.now(),
//                         objective: '',
//                         keyResults: Array.from({ length: 6 }, () => ({
//                             text: '',
//                             result: 'Pending'
//                         }))
//                     }
//                 ]);
//             }

//         } catch (err) {
//             console.error(err);
//         }
//     }, [userData]);

//     useEffect(() => {
//         if (selectedQuarter) {
//             loadExistingOKR(selectedYear, selectedQuarter);
//         }
//     }, [selectedYear, selectedQuarter, loadExistingOKR]);

//     useEffect(() => {
//         const fetchLock = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/get_timeline_lock.php?year=${selectedYear}&quarter=${selectedQuarter}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();
//                 console.log("CHECK LOCK API:", selectedYear, selectedQuarter);

//                 if (data.success) {
//                     setIsTimelineLockedFromDB(data.locked === true || data.locked === "true" || data.locked == 1);
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         if (selectedYear && selectedQuarter) {
//             fetchLock();
//         }
//     }, [selectedYear, selectedQuarter]);

//     const fetchHistory = useCallback(async () => {
//         if (!userData?.EmpId) return;
//         try {
//             const res = await fetch(
//                 `/gt-api/get_okr_history.php?empId=${userData.EmpId}`,
//                 {
//                     credentials: "include"
//                 }
//             );
//             const data = await res.json();
//             setHistory(data || []);
//         } catch (err) { console.error(err); }
//     }, [userData]);

//     useEffect(() => {
//         fetchHistory();
//     }, [fetchHistory]);

//     useEffect(() => {
//         if (defaultTab) {
//             setActiveTab(defaultTab);
//         }
//     }, [defaultTab]);

//     const getQuarterStatusLabel = (q) => {
//         const record = history.find(h => h.quarter === q && h.year.toString() === selectedYear.toString());
//         if (!record) return "";
//         const status = record.workflow_status;
//         if (status === 'Locked' || status === 'Sign_Off') return " (Locked)";
//         return ` (${status.replace(/_/g, ' ')})`;
//     };

//     const handleInputChange = (id, field, value, krIndex = null) => {
//         setOkrRows(prev => prev.map(row => {
//             if (row.id !== id) return row;
//             if (krIndex !== null) {
//                 const krs = [...row.keyResults];
//                 krs[krIndex] = { ...krs[krIndex], [field]: value };
//                 return { ...row, keyResults: krs };
//             }
//             return { ...row, [field]: value };
//         }));
//     };

//     const handleReviewChange = (sectionId, index, value) => {
//         setReviewData(prev => {
//             const updatedSection = [...prev[sectionId]];
//             updatedSection[index] = value;
//             return { ...prev, [sectionId]: updatedSection };
//         });
//     };

//     const addNewObjective = () => {
//         if (okrRows.length >= 6) return;
//         setOkrRows(prev => [...prev, {
//             id: Date.now(),
//             objective: '',
//             keyResults: Array.from({ length: 6 }, () => ({ text: '', result: 'Pending' }))
//         }]);
//     };

//     const deleteObjective = (id) => {
//         if (okrRows.length === 1) return;
//         setOkrRows(prev => prev.filter(o => o.id !== id));
//     };

//     const [managementNotices, setManagementNotices] = useState({ reviews: [], probations: [] });

//     const fetchNotices = useCallback(async () => {
//         if (!userData?.EmpId) return;
//         try {
//             const res = await fetch(
//                 `/gt-api/get_manager_feedback.php?empId=${userData.EmpId}`,
//                 {
//                     credentials: "include"
//                 }
//             );
//             const data = await res.json();
//             if (data.success) {
//                 setManagementNotices({
//                     reviews: data.reviews || [],
//                     probations: data.probations || []
//                 });
//             }
//         } catch (err) { console.error(err); }
//     }, [userData]);

//     useEffect(() => {
//         if (activeTab === "Manager Review") {
//             fetchNotices();
//             localStorage.setItem("seen_reviews", new Date().toISOString());
//         }

//         if (activeTab === "Probation Period Feedback") {
//             fetchNotices();
//             localStorage.setItem("seen_probation", new Date().toISOString());
//         }
//     }, [activeTab, fetchNotices]);

//     const handleViewFromLog = (year, quarter) => {
//         setSelectedYear(year);
//         setSelectedQuarter(quarter);
//         loadExistingOKR(year, quarter, true);
//         setActiveTab("OKR Tracker");
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//     };

//     const syncToGenesis = async () => {
//         if (!selectedYear || !selectedQuarter) {
//             alert("Please select a quarter first.");
//             return;
//         }

//         if (
//             isTimelineLockedFromDB &&
//             workflowStep !== 'Returned_To_Employee' &&
//             workflowStep !== 'Scoring'
//         ) {
//             alert("This quarter is locked.");
//             return;
//         }

//         setIsSyncing(true);

//         try {
//             const res = await fetch('/gt-api/submit_okr.php', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 credentials: "include",
//                 body: JSON.stringify({
//                     empId: userData.EmpId,
//                     empName: userData.DisplayName,
//                     department: userData.Department,
//                     year: selectedYear,
//                     quarter: selectedQuarter,
//                     okrData: okrRows,
//                     status:
//                         workflowStep === 'Planning' || workflowStep === 'Returned_To_Employee'
//                             ? 'Management_Review'
//                             : 'Manager_Scoring_Review'
//                 })
//             });

//             const text = await res.text();
//             console.log("RAW RESPONSE:", text);

//             let data;
//             try {
//                 data = JSON.parse(text);
//             } catch {
//                 // 🔥 even if JSON fails → assume success (since DB saved)
//                 setModalMsg("Saved successfully!");
//                 setShowModal(true);
//                 fetchHistory();
//                 return;
//             }

//             // ✅ flexible success handling
//             if (data.success || data.status === "ok") {
//                 setModalMsg("Saved successfully!");
//                 setShowModal(true);
//                 fetchHistory();
//             } else {
//                 alert("Something went wrong: " + (data.message || text));
//             }

//         } catch (err) {
//             console.error(err);
//             alert("Network error. Failed to save.");
//         } finally {
//             setIsSyncing(false);
//         }
//     };


//     const submitSelfReview = async (e) => {
//         e.preventDefault();
//         setIsSyncing(true);
//         try {
//             const res = await fetch('/gt-api/submit_employee_review.php', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 credentials: "include",
//                 body: JSON.stringify({
//                     empid: userData.EmpId,
//                     full_name: userData.DisplayName,
//                     team: userData.Department,
//                     job_title: reviewData.job_title,
//                     review_period: reviewData.review_period,
//                     achievements: reviewData.achievements,
//                     responsibilities: reviewData.responsibilities,
//                     skills_growth: reviewData.skills_growth,
//                     challenges: reviewData.challenges,
//                     improvement_areas: reviewData.improvement_areas,
//                     goals_next_year: reviewData.goals_next_year,
//                     additional_contributions: reviewData.additional_contributions,
//                     support_needed: reviewData.support_needed
//                 })
//             });
//             const data = await res.json();

//             if (data.success) {
//                 setModalMsg("Your self-review has been submitted successfully!");
//                 setShowModal(true);
//             } else {
//                 alert("Failed to submit review: " + data.message);
//             }
//         } catch { alert("Network error. Failed to submit review."); } finally { setIsSyncing(false); }
//     };

//     const canEditOKR =
//         (
//             (!isTimelineLockedFromDB && workflowStep === 'Planning') ||
//             workflowStep === 'Returned_To_Employee'
//         ) &&
//         selectedQuarter !== "";

//     const canScore =
//         workflowStep === 'Scoring' &&
//         (workflowStep === 'Scoring') &&
//         selectedQuarter !== "";
//     const updateProgress = async () => {
//         if (!selectedYear || !selectedQuarter) return;

//         setIsSyncing(true);

//         try {
//             const res = await fetch('/gt-api/update_okr_progress.php', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 credentials: "include",
//                 body: JSON.stringify({
//                     empId: userData.EmpId,
//                     year: selectedYear,
//                     quarter: selectedQuarter,
//                     okrData: okrRows
//                 })
//             });

//             const data = await res.json();

//             console.log("SERVER RESPONSE:", data);

//             if (data.success) {
//                 setModalMsg("Progress updated successfully!");
//                 setShowModal(true);

//                 // ❌ old (keep or remove, doesn't matter)
//                 localStorage.setItem("okr_updated", Date.now());

//                 // ✅ ADD THIS (THIS IS THE REAL FIX)
//                 window.dispatchEvent(new Event("okrUpdated"));
//             }
//         } catch (err) {
//             console.error(err);
//             alert("Network error");
//         } finally {
//             setIsSyncing(false);
//         }
//     };
//     const isEmployeeTurn = ['Planning', 'Scoring', 'Returned_To_Employee'].includes(workflowStep);

//     const isLocked = workflowStep === 'Locked' || workflowStep === 'Sign_Off';



//     const renderSubModule = () => {
//         switch (activeTab) {
//             case "OKR Tracker":
//                 return (
//                     <div className="okr-genesis-container">
//                         {showModal && createPortal(
//                             <div className="okrmodaloverlay" style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'fixed', inset: 0, zIndex: 100000 }}>
//                                 <div className="okr-success-modal animate-pop" style={{ backgroundColor: '#ffffff', padding: '40px', borderRadius: '16px', textAlign: 'center', maxWidth: '400px', width: '90%', boxShadow: '0 20px 40px rgba(0,0,0,0.2)' }}>
//                                     <div className="success-icon-container" style={{ backgroundColor: '#e8f5e9', width: '60px', height: '60px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
//                                         <div className="check-mark" style={{ color: '#2e7d32', fontSize: '30px', fontWeight: 'bold' }}>✓</div>
//                                     </div>
//                                     <h2 style={{ color: '#1a1a1a', marginBottom: '10px', fontSize: '1.5rem' }}>All Set!</h2>
//                                     <p style={{ color: '#666666', marginBottom: '30px', lineHeight: '1.5' }}>{modalMsg}</p>
//                                     <button className="btn-modal-continue" onClick={() => window.location.reload()} style={{ backgroundColor: '#2196F3', color: '#ffffff', border: 'none', padding: '12px 30px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', width: '100%' }}>CONTINUE</button>
//                                 </div>
//                             </div>,
//                             document.body
//                         )}

//                         <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
//                             <div className="okr-glass-card" style={{ width: '100%' }}>
//                                 <header className="okr-view-header">
//                                     <div className="title-group">
//                                         <div className="status-badge"><span className="pulse-ring"></span></div>
//                                         <h1>OKR <span className="blue-gradient-text">Tracker</span></h1>
//                                     </div>
//                                     <div className="header-actions">
//                                         <select className="time-select-modern" value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
//                                             {yearOptions.map(y => <option key={y} value={y}>{y}</option>)}
//                                         </select>

//                                         <select
//                                             className="time-select-modern"
//                                             value={selectedQuarter}
//                                             onChange={(e) => setSelectedQuarter(e.target.value)}
//                                         >
//                                             <option value="" disabled>Select Quarter</option>

//                                             {quarterOptions.map(q => {
//                                                 const currentQuarter = getCurrentQuarterLimit(currentMonth);
//                                                 const isCurrentYear = selectedYear === getFY(today);

//                                                 const isFutureQuarter =
//                                                     isCurrentYear &&
//                                                     quarterOptions.indexOf(q) > quarterOptions.indexOf(currentQuarter);

//                                                 // 🔥 USE EXISTING STATE (NO NEW API)
//                                                 const isLockedFromDB =
//                                                     selectedQuarter === q && isTimelineLockedFromDB;

//                                                 const isDisabled = isFutureQuarter || isLockedFromDB;

//                                                 return (
//                                                     <option key={q} value={q} disabled={isDisabled}>
//                                                         {q} {isLockedFromDB ? "🔒 Locked" : ""}
//                                                     </option>
//                                                 );
//                                             })}
//                                         </select>

//                                         <span className="node-count">
//                                             {userData ? `${userData.DisplayName.toUpperCase()} | ${isLocked ? 'LOCKED' : workflowStep.replace(/_/g, ' ')}` : "CONNECTING..."}
//                                         </span>
//                                     </div>
//                                 </header>

//                                 <div className="okr-table-wrapper">
//                                     <table className="okr-modern-table">
//                                         <thead>
//                                             <tr><th width="35%">Goal Objective</th><th width="45%">Key Results (6)</th><th width="20%">Status</th></tr>
//                                         </thead>
//                                         <tbody>
//                                             {okrRows.map((row, rowIdx) => (
//                                                 <React.Fragment key={row.id}>
//                                                     {row.keyResults.map((kr, idx) => (
//                                                         <tr
//                                                             key={kr._krId || `${row.id}-${idx}`}
//                                                             className={`data-row ${idx === row.keyResults.length - 1 ? 'block-end' : ''}`}
//                                                         >
//                                                             {idx === 0 && (
//                                                                 <td rowSpan={row.keyResults.length} className="objective-spanned-cell">
//                                                                     <div className="obj-header-row">
//                                                                         <div className="obj-number">
//                                                                             Goal {rowIdx + 1}
//                                                                         </div>

//                                                                         {(
//                                                                             (workflowStep === 'Returned_To_Employee') ||
//                                                                             !isTimelineLockedFromDB
//                                                                         ) && canEditOKR && okrRows.length > 1 && (
//                                                                                 <button
//                                                                                     className="btn-delete-obj"
//                                                                                     onClick={() => deleteObjective(row.id)}
//                                                                                 >
//                                                                                     ✕
//                                                                                 </button>
//                                                                             )}
//                                                                     </div>

//                                                                     <textarea
//                                                                         className="obj-textarea"
//                                                                         placeholder={
//                                                                             selectedQuarter
//                                                                                 ? "What is your main focus?..."
//                                                                                 : "Select a quarter to begin..."
//                                                                         }
//                                                                         value={row.objective}
//                                                                         disabled={!canEditOKR}
//                                                                         onChange={(e) => {
//                                                                             handleInputChange(row.id, 'objective', e.target.value);
//                                                                             autoResize(e.target);
//                                                                         }}
//                                                                     />
//                                                                 </td>
//                                                             )}

//                                                             <td className="kr-cell">
//                                                                 <div className="kr-input-wrapper">
//                                                                     <span className="kr-index">
//                                                                         0{idx + 1}
//                                                                     </span>

//                                                                     <textarea
//                                                                         className="kr-single-textarea"
//                                                                         placeholder="Key measure..."
//                                                                         value={kr.text}
//                                                                         disabled={!canEditOKR}
//                                                                         onChange={(e) => {
//                                                                             handleInputChange(row.id, 'text', e.target.value, idx);
//                                                                             autoResize(e.target);
//                                                                         }}
//                                                                     />
//                                                                 </div>

//                                                                 {kr.ar_comment && (
//                                                                     <div
//                                                                         style={{
//                                                                             marginTop: '6px',
//                                                                             padding: '8px',
//                                                                             borderRadius: '6px',
//                                                                             background: 'rgba(255,152,0,0.08)',
//                                                                             borderLeft: '3px solid #ff9800',
//                                                                             fontSize: '12px',
//                                                                         }}
//                                                                     >
//                                                                         <strong>AR:</strong> {kr.ar_comment}
//                                                                     </div>
//                                                                 )}
//                                                             </td>

//                                                             <td>
//                                                                 <select
//                                                                     className="modern-select"
//                                                                     value={kr.result}
//                                                                     disabled={!canScore}
//                                                                     onChange={(e) =>
//                                                                         handleInputChange(row.id, 'result', e.target.value, idx)
//                                                                     }
//                                                                 >
//                                                                     {resultOptions.map((opt) => (
//                                                                         <option key={opt} value={opt}>
//                                                                             {opt}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             </td>
//                                                         </tr>
//                                                     ))}
//                                                 </React.Fragment>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>

//                                 <footer className="okr-footer">
//                                     <div className="footer-left">
//                                         {((workflowStep === 'Returned_To_Employee') || !isTimelineLockedFromDB) && canEditOKR && okrRows.length < 6 && (
//                                             <button className="btn-add-objective" onClick={addNewObjective}>+ Add another Goal ({okrRows.length}/6)</button>
//                                         )}
//                                     </div>
//                                     <div className="footer-right">

//                                         {/* 🔥 NEW BUTTON */}
//                                         {canScore && !isLocked && (
//                                             <button
//                                                 className="btn-secondary"
//                                                 onClick={updateProgress}
//                                                 disabled={isSyncing}
//                                             >
//                                                 {isSyncing ? "Updating..." : "Update Progress"}
//                                             </button>
//                                         )}

//                                         {/* EXISTING BUTTON */}
//                                         {selectedQuarter &&
//                                             isEmployeeTurn &&
//                                             !isLocked &&
//                                             (
//                                                 workflowStep === 'Returned_To_Employee' ||
//                                                 workflowStep === 'Scoring' ||
//                                                 !isTimelineLockedFromDB
//                                             ) && (
//                                                 <button className="btn-primary" onClick={syncToGenesis} disabled={isSyncing}>
//                                                     {isSyncing
//                                                         ? "Saving..."
//                                                         : workflowStep === 'Returned_To_Employee'
//                                                             ? "Resubmit"
//                                                             : workflowStep === 'Planning'
//                                                                 ? "Send for Review"
//                                                                 : "Submit"}
//                                                 </button>
//                                             )}

//                                     </div>
//                                 </footer>
//                             </div>

//                             <div className="okr-glass-card" style={{ width: '100%', padding: '20px' }}>
//                                 <h3 className="blue-gradient-text" style={{ fontSize: '1.1rem', marginBottom: '15px' }}>MY HISTORY</h3>
//                                 <div className="okr-table-wrapper">
//                                     {isTimelineLockedFromDB && (
//                                         <div style={{
//                                             background: "#ff4d4f",
//                                             color: "#fff",
//                                             padding: "10px",
//                                             borderRadius: "6px",
//                                             textAlign: "center",
//                                             fontWeight: "600",
//                                             marginBottom: "10px"
//                                         }}>
//                                             🔒 This quarter is locked by management
//                                         </div>
//                                     )}
//                                     <table className="okr-modern-table">
//                                         <thead>
//                                             <tr><th>Period</th><th>Submitted On</th><th>Status</th><th style={{ textAlign: 'right' }}>Action</th></tr>
//                                         </thead>
//                                         <tbody>
//                                             {history.map((item) => (
//                                                 <tr key={item.id} className="data-row">
//                                                     <td style={{ fontWeight: '600' }}>{item.quarter} {item.year}</td>
//                                                     <td style={{ opacity: 0.6 }}>{new Date(item.submitted_at).toLocaleDateString()}</td>
//                                                     <td>
//                                                         <span className="status-pill-mini">
//                                                             {item.workflow_status === 'Locked' || item.workflow_status === 'Sign_Off' ? '🔒 Locked' : item.workflow_status.replace(/_/g, ' ')}
//                                                         </span>
//                                                     </td>
//                                                     <td style={{ textAlign: 'right' }}>
//                                                         <button className="btn-view-data" onClick={() => handleViewFromLog(item.year, item.quarter)}>VIEW DATA</button>
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>


//                             </div>
//                         </div>
//                     </div>
//                 );




//             case "Employee Self Performance Review":
//                 return (
//                     <div className="okr-genesis-container animate-fade">
//                         {showModal && (
//                             <div className="modal-overlay" style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'fixed', inset: 0, zIndex: 1000, backdropFilter: 'blur(10px)' }}>
//                                 <div className="okr-success-modal animate-pop" style={{ background: '#111', border: '1px solid #00bcd4', padding: '40px', borderRadius: '20px', textAlign: 'center', maxWidth: '400px', width: '90%' }}>
//                                     <div style={{ fontSize: '40px', marginBottom: '15px' }}>📋</div>
//                                     <h2 className="blue-gradient-text">Review Submitted</h2>
//                                     <p style={{ color: 'rgba(255,255,255,0.7)', marginBottom: '25px' }}>{modalMsg}</p>
//                                     <button className="btn-modal-continue" onClick={() => window.location.reload()} style={{ background: '#00bcd4', color: '#000', border: 'none', padding: '12px 25px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>OK</button>
//                                 </div>
//                             </div>
//                         )}

//                         <div className="review-document-container" style={{ maxWidth: '950px', margin: '0 auto', paddingBottom: '50px' }}>
//                             <div className="review-doc-paper" style={{ background: 'rgba(255, 255, 255, 0.03)', backdropFilter: 'blur(20px)', border: '1px solid rgba(255, 255, 255, 0.1)', borderRadius: '12px', padding: '50px' }}>

//                                 <div className="doc-header-grid" style={{ display: 'flex', gap: '40px', borderBottom: '2px solid #00bcd4', paddingBottom: '30px', marginBottom: '40px' }}>
//                                     <div className="doc-logo-section">
//                                         <img src={logoImg} alt="Logo" style={{ maxWidth: '140px', height: 'auto', filter: 'brightness(1.2)' }} />
//                                     </div>
//                                     <div className="doc-title-section">
//                                         <h1 style={{ fontSize: '2.2rem', fontWeight: '800', margin: '0 0 10px 0', color: '#fff' }}>Employee Annual Self-Review Form</h1>
//                                         <p style={{ fontSize: '0.95rem', lineHeight: '1.6', opacity: 0.7, color: '#fff' }}>
//                                             Please complete this self-review to reflect on your performance. <strong>Provide 5 points for each section.</strong>
//                                         </p>
//                                     </div>
//                                 </div>

//                                 <form onSubmit={submitSelfReview}>
//                                     <div className="doc-section" style={{ marginBottom: '40px' }}>
//                                         <h3 style={{ color: '#00bcd4', textTransform: 'uppercase', fontSize: '0.85rem', letterSpacing: '2px', marginBottom: '20px' }}>SECTION 1 — Basic Information</h3>
//                                         <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
//                                             <div className="doc-field">
//                                                 <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.6, marginBottom: '5px', color: '#fff' }}>1. Full Name:</label>
//                                                 <input type="text" className="doc-underlined-input" value={userData?.DisplayName} readOnly />
//                                             </div>
//                                             <div className="doc-field">
//                                                 <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.6, marginBottom: '5px', color: '#fff' }}>2. Job Title:</label>
//                                                 <input type="text" className="doc-underlined-input" placeholder="Your Title..." onChange={(e) => setReviewData({ ...reviewData, job_title: e.target.value })} />
//                                             </div>
//                                             <div className="doc-field">
//                                                 <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.6, marginBottom: '5px', color: '#fff' }}>3. Team:</label>
//                                                 <input type="text" className="doc-underlined-input" value={userData?.Department} readOnly />
//                                             </div>
//                                             <div className="doc-field">
//                                                 <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.6, marginBottom: '5px', color: '#fff' }}>4. Review Period:</label>
//                                                 <input type="text" className="doc-underlined-input" placeholder="Jan 2025 – Dec 2025" required onChange={(e) => setReviewData({ ...reviewData, review_period: e.target.value })} />
//                                             </div>
//                                         </div>
//                                     </div>

//                                     {[
//                                         { id: 'achievements', title: 'SECTION 2 — Key Achievements', instruction: 'List your top achievements this year:' },
//                                         { id: 'responsibilities', title: 'SECTION 3 — Role & Responsibilities', instruction: 'Describe your main responsibilities and any additional tasks:' },
//                                         { id: 'skills_growth', title: 'SECTION 4 — Skills & Growth', instruction: 'What new skills or knowledge did you acquire?' },
//                                         { id: 'challenges', title: 'SECTION 5 — Challenges', instruction: 'What challenges did you face and how did you handle them?' },
//                                         { id: 'improvement_areas', title: 'SECTION 6 — Improvement Areas', instruction: 'What areas do you want to improve next year?' },
//                                         { id: 'goals_next_year', title: 'SECTION 7 — Goals for Next Year', instruction: 'List goals you want to work on next year:' },
//                                         { id: 'additional_contributions', title: 'SECTION 8 — Additional Contributions', instruction: 'Mention team support, mentoring, or other initiatives:' },
//                                         { id: 'support_needed', title: 'SECTION 9 — Support Needed', instruction: 'What resources do you need from your manager?' }
//                                     ].map((section) => (
//                                         <div className="doc-section" key={section.id} style={{ marginBottom: '35px' }}>
//                                             <h3 style={{ color: '#00bcd4', textTransform: 'uppercase', fontSize: '0.85rem', letterSpacing: '2px', marginBottom: '10px' }}>{section.title}</h3>
//                                             <p style={{ fontSize: '0.9rem', marginBottom: '15px', fontWeight: '500', color: '#fff' }}>{section.instruction}</p>

//                                             <div className="five-point-container" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
//                                                 {[0, 1, 2, 3, 4].map((idx) => (
//                                                     <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: '15px', background: 'rgba(255,255,255,0.02)', padding: '10px 15px', borderRadius: '4px' }}>
//                                                         <span style={{ fontSize: '0.8rem', opacity: 0.4, color: '#00bcd4', fontWeight: 'bold', marginTop: '4px' }}>{idx + 1}.</span>
//                                                         <textarea
//                                                             placeholder="..."
//                                                             className="doc-point-textarea"
//                                                             rows="1"
//                                                             value={reviewData[section.id][idx]}
//                                                             onChange={(e) => {
//                                                                 handleReviewChange(section.id, idx, e.target.value);
//                                                                 autoResize(e.target);
//                                                             }}
//                                                             style={{
//                                                                 width: '100%',
//                                                                 background: 'transparent',
//                                                                 border: 'none',
//                                                                 color: '#fff',
//                                                                 outline: 'none',
//                                                                 resize: 'none',
//                                                                 overflow: 'hidden',
//                                                                 padding: '0',
//                                                                 lineHeight: '1.5'
//                                                             }}
//                                                         />
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         </div>
//                                     ))}

//                                     <div style={{ textAlign: 'center', marginTop: '50px' }}>
//                                         <button type="submit" className="doc-submit-btn" disabled={isSyncing} style={{ background: '#00bcd4', color: '#000', border: 'none', padding: '18px 60px', borderRadius: '4px', fontWeight: '800', cursor: 'pointer', transition: '0.3s' }}>
//                                             {isSyncing ? "SAVING DATA..." : "SUBMIT COMPLETED REVIEW"}
//                                         </button>
//                                     </div>
//                                 </form>
//                             </div>
//                         </div>
//                     </div>
//                 );

//             case "Manager Review":
//                 return (
//                     <div className="okr-genesis-container animate-fade">
//                         <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
//                             <h2 className="blue-gradient-text">Manager Review</h2>
//                             {managementNotices.reviews.length > 0 ? (
//                                 managementNotices.reviews.map((item, index) => (
//                                     <div key={index} className="okr-glass-card" style={{ padding: '20px', borderLeft: '4px solid #00bcd4' }}>
//                                         <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', opacity: 0.6, fontSize: '0.8rem' }}>
//                                             <span>OFFICIAL REVIEW</span>
//                                             <span>{new Date(item.created_at).toLocaleDateString()}</span>
//                                         </div>
//                                         <div style={{ color: '#fff', whiteSpace: 'pre-wrap', lineHeight: '1.6' }}>{item.content}</div>
//                                     </div>
//                                 ))
//                             ) : (
//                                 <div className="okr-glass-card" style={{ padding: '20px', textAlign: 'center', opacity: 0.5 }}>No reviews found.</div>
//                             )}
//                         </div>
//                     </div>
//                 );

//             case "Probation Period Feedback":
//                 return (
//                     <div className="okr-genesis-container animate-fade">
//                         <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
//                             <h2 className="blue-gradient-text">Probation Notice</h2>
//                             {managementNotices.probations.length > 0 ? (
//                                 managementNotices.probations.map((item, index) => (
//                                     <div key={index} className="okr-glass-card" style={{ padding: '20px', borderLeft: '4px solid #ff5252' }}>
//                                         <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', opacity: 0.6, fontSize: '0.8rem' }}>
//                                             <span>NOTICE OF PROBATION</span>
//                                             <span>{new Date(item.created_at).toLocaleDateString()}</span>
//                                         </div>
//                                         <div style={{ color: '#fff', whiteSpace: 'pre-wrap', lineHeight: '1.6' }}>{item.content}</div>
//                                     </div>
//                                 ))
//                             ) : (
//                                 <div className="okr-glass-card" style={{ padding: '20px', textAlign: 'center', opacity: 0.5 }}>No probation notices found.</div>
//                             )}
//                         </div>
//                     </div>
//                 );



//             default: return null;
//         }
//     };

//     return (
//         <div className="pay-module">
//             <div className="pay-nav-grid">
//                 {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//                     <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => setActiveTab(tab)}>
//                         {tab.toUpperCase()}
//                     </button>
//                 ))}
//             </div>
//             <div className="pay-content-area">
//                 {renderSubModule()}
//             </div>
//         </div>
//     );
// };

// export default OKRTracker;




















// import React, { useState, useEffect, useCallback } from 'react';
// import { createPortal } from 'react-dom';
// import { Trash2 } from 'lucide-react';
// import logoImg from '../assets/logo.jpg';
// import '../styles/OKRTracker.css';

// const OKRTracker = ({ userData: propUserData, defaultTab }) => {

//     const [lockedQuarters, setLockedQuarters] = useState({});

//     const [activeTab, setActiveTab] = useState("OKR Tracker");

//     /* ---------- FINANCIAL YEAR & QUARTER LOGIC ---------- */
//     const today = new Date();
//     const currentMonth = today.getMonth() + 1;

//     const getFY = (date) => {
//         const m = date.getMonth() + 1;
//         const y = date.getFullYear();
//         return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//     };

//     const getCurrentQuarterLimit = (month) => {
//         if (month >= 4 && month <= 6) return 'Quarter 1';
//         if (month >= 7 && month <= 9) return 'Quarter 2';
//         if (month >= 10 && month <= 12) return 'Quarter 3';
//         return 'Quarter 4';
//     };

//     const [userData, setUserData] = useState(null);
//     const [isSyncing, setIsSyncing] = useState(false);
//     const [isTimelineLockedFromDB, setIsTimelineLockedFromDB] = useState(false);
//     const [selectedYear, setSelectedYear] = useState(getFY(today));
//     const [selectedQuarter, setSelectedQuarter] = useState("");

//     const [history, setHistory] = useState([]);
//     const [workflowStep, setWorkflowStep] = useState('Planning');
//     const [showModal, setShowModal] = useState(false);
//     const [modalMsg, setModalMsg] = useState('');

//     /* ---------- EMPLOYEE REVIEW STATE ---------- */
//     const [reviewData, setReviewData] = useState({
//         review_period: '',
//         job_title: '',
//         achievements: Array(5).fill(''),
//         responsibilities: Array(5).fill(''),
//         skills_growth: Array(5).fill(''),
//         challenges: Array(5).fill(''),
//         improvement_areas: Array(5).fill(''),
//         goals_next_year: Array(5).fill(''),
//         additional_contributions: Array(5).fill(''),
//         support_needed: Array(5).fill('')
//     });

//     const [okrRows, setOkrRows] = useState([
//         {
//             id: Date.now(),
//             objective: '',
//             keyResults: Array.from({ length: 6 }, () => ({ text: '', result: 'Pending' }))
//         }
//     ]);

//     const resultOptions = ['Pending', 'Not Met/ Downgraded', 'Successfull', 'Exceeds', 'Excellence'];
//     const quarterOptions = ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'];
//     const yearOptions = ["2024-2025", "2025-2026", "2026-2027"];

//     /* ---------- AUTO-RESIZE LOGIC ---------- */
//     const autoResize = (target) => {
//         if (target) {
//             target.style.height = 'auto';
//             target.style.height = `${target.scrollHeight}px`;
//         }
//     };

//     // Re-run resize when tabs change or data loads
//     useEffect(() => {
//         const textareas = document.querySelectorAll('.obj-textarea, .kr-single-textarea, .doc-point-textarea');
//         textareas.forEach(el => autoResize(el));
//     }, [okrRows, activeTab, reviewData]);

//     useEffect(() => {
//         if (propUserData) {
//             setUserData({
//                 EmpId: propUserData.EmpId || propUserData.id,
//                 DisplayName: `${propUserData.firstName || ''} ${propUserData.lastName || ''}`.trim(),
//                 Department: propUserData.Department || ''
//             });
//         }
//     }, [propUserData]);





//     useEffect(() => {
//         const fetchAllLocks = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/get_timeline_lock.php?year=${selectedYear}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 if (data.success && data.data) {
//                     const lockMap = {};
//                     data.data.forEach(item => {
//                         lockMap[item.quarter] = item.locked == 1;
//                     });
//                     setLockedQuarters(lockMap);
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         if (selectedYear) fetchAllLocks();
//     }, [selectedYear]);

//     const loadExistingOKR = useCallback(async (year, quarter, force = false) => {
//         if (!userData?.EmpId || !year || !quarter) return;

//         try {
//             const res = await fetch(
//                 `/gt-api/get_user_okr.php?empId=${userData.EmpId}&year=${year}&quarter=${quarter}`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await res.json();

//             if (data.success) {

//                 // ✅ DEEP CLONE (VERY IMPORTANT)
//                 const parsedRaw =
//                     typeof data.data === 'string'
//                         ? JSON.parse(data.data)
//                         : data.data;

//                 const parsed = JSON.parse(JSON.stringify(parsedRaw));

//                 // ✅ CLEAN + REBUILD DATA
//                 const cleanedData = parsed.map((obj) => {
//                     return {
//                         ...obj,
//                         id: obj.id || `${Date.now()}-${Math.random()}`, // 🔥 ensure unique objective id
//                         keyResults: Array.from({ length: 6 }, (_, i) => {
//                             const kr = obj.keyResults?.[i] || {};

//                             const newKR = {
//                                 text: kr.text ? String(kr.text) : '',
//                                 result: kr.result ? String(kr.result) : 'Pending',
//                                 ar_comment: kr.ar_comment ? String(kr.ar_comment) : '',
//                                 _krId: `${i}-${Date.now()}-${Math.random()}` // 🔥 UNIQUE PER KR
//                             };

//                             if (
//                                 data.workflow_status === 'Scoring' ||
//                                 data.workflow_status === 'Sign_Off' ||
//                                 data.workflow_status === 'Locked'
//                             ) {
//                                 delete newKR.ar_comment;
//                             }

//                             return { ...newKR }; // 🔥 force new object
//                         })
//                     };
//                 });

//                 setOkrRows(cleanedData);
//                 setWorkflowStep(data.workflow_status);

//             } else if (force || !data.success) {

//                 setWorkflowStep('Planning');

//                 setOkrRows([
//                     {
//                         id: Date.now(),
//                         objective: '',
//                         keyResults: Array.from({ length: 6 }, () => ({
//                             text: '',
//                             result: 'Pending'
//                         }))
//                     }
//                 ]);
//             }

//         } catch (err) {
//             console.error(err);
//         }
//     }, [userData]);

//     useEffect(() => {
//         if (selectedQuarter) {
//             loadExistingOKR(selectedYear, selectedQuarter);
//         }
//     }, [selectedYear, selectedQuarter, loadExistingOKR]);

//     useEffect(() => {
//         const fetchLock = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/get_timeline_lock.php?year=${selectedYear}&quarter=${selectedQuarter}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();
//                 console.log("CHECK LOCK API:", selectedYear, selectedQuarter);

//                 if (data.success) {
//                     setIsTimelineLockedFromDB(data.locked === true || data.locked === "true" || data.locked == 1);
//                 }
//             } catch (err) {
//                 console.error(err);
//             }
//         };

//         if (selectedYear && selectedQuarter) {
//             fetchLock();
//         }
//     }, [selectedYear, selectedQuarter]);

//     const fetchHistory = useCallback(async () => {
//         if (!userData?.EmpId) return;
//         try {
//             const res = await fetch(
//                 `/gt-api/get_okr_history.php?empId=${userData.EmpId}`,
//                 {
//                     credentials: "include"
//                 }
//             );
//             const data = await res.json();
//             setHistory(data || []);
//         } catch (err) { console.error(err); }
//     }, [userData]);

//     useEffect(() => {
//         fetchHistory();
//     }, [fetchHistory]);

//     useEffect(() => {
//         if (defaultTab) {
//             setActiveTab(defaultTab);
//         }
//     }, [defaultTab]);

//     const getQuarterStatusLabel = (q) => {
//         const record = history.find(h => h.quarter === q && h.year.toString() === selectedYear.toString());
//         if (!record) return "";
//         const status = record.workflow_status;
//         if (status === 'Locked' || status === 'Sign_Off') return " (Locked)";
//         return ` (${status.replace(/_/g, ' ')})`;
//     };

//     const handleInputChange = (id, field, value, krIndex = null) => {
//         setOkrRows(prev => prev.map(row => {
//             if (row.id !== id) return row;
//             if (krIndex !== null) {
//                 const krs = [...row.keyResults];
//                 krs[krIndex] = { ...krs[krIndex], [field]: value };
//                 return { ...row, keyResults: krs };
//             }
//             return { ...row, [field]: value };
//         }));
//     };

//     const handleReviewChange = (sectionId, index, value) => {
//         setReviewData(prev => {
//             const updatedSection = [...prev[sectionId]];
//             updatedSection[index] = value;
//             return { ...prev, [sectionId]: updatedSection };
//         });
//     };

//     const addNewObjective = () => {
//         if (okrRows.length >= 6) return;
//         setOkrRows(prev => [...prev, {
//             id: Date.now(),
//             objective: '',
//             keyResults: Array.from({ length: 6 }, () => ({ text: '', result: 'Pending' }))
//         }]);
//     };

//     const deleteObjective = (id) => {
//         if (okrRows.length === 1) return;
//         setOkrRows(prev => prev.filter(o => o.id !== id));
//     };

//     const [managementNotices, setManagementNotices] = useState({ reviews: [], probations: [] });

//     const fetchNotices = useCallback(async () => {
//         if (!userData?.EmpId) return;
//         try {
//             const res = await fetch(
//                 `/gt-api/get_manager_feedback.php?empId=${userData.EmpId}`,
//                 {
//                     credentials: "include"
//                 }
//             );
//             const data = await res.json();
//             if (data.success) {
//                 setManagementNotices({
//                     reviews: data.reviews || [],
//                     probations: data.probations || []
//                 });
//             }
//         } catch (err) { console.error(err); }
//     }, [userData]);

//     useEffect(() => {
//         if (activeTab === "Manager Review") {
//             fetchNotices();
//             localStorage.setItem("seen_reviews", new Date().toISOString());
//         }

//         if (activeTab === "Probation Period Feedback") {
//             fetchNotices();
//             localStorage.setItem("seen_probation", new Date().toISOString());
//         }
//     }, [activeTab, fetchNotices]);

//     const handleViewFromLog = (year, quarter) => {
//         setSelectedYear(year);
//         setSelectedQuarter(quarter);
//         loadExistingOKR(year, quarter, true);
//         setActiveTab("OKR Tracker");
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//     };

//     const syncToGenesis = async () => {
//         if (!selectedYear || !selectedQuarter) {
//             alert("Please select a quarter first.");
//             return;
//         }

//         if (
//             isTimelineLockedFromDB &&
//             workflowStep !== 'Returned_To_Employee' &&
//             workflowStep !== 'Scoring'
//         ) {
//             alert("This quarter is locked.");
//             return;
//         }

//         setIsSyncing(true);

//         try {
//             const res = await fetch('/gt-api/submit_okr.php', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 credentials: "include",
//                 body: JSON.stringify({
//                     empId: userData.EmpId,
//                     empName: userData.DisplayName,
//                     department: userData.Department,
//                     year: selectedYear,
//                     quarter: selectedQuarter,
//                     okrData: okrRows,
//                     status:
//                         workflowStep === 'Planning' || workflowStep === 'Returned_To_Employee'
//                             ? 'Management_Review'
//                             : 'Manager_Scoring_Review'
//                 })
//             });

//             const text = await res.text();
//             console.log("RAW RESPONSE:", text);

//             let data;
//             try {
//                 data = JSON.parse(text);
//             } catch {
//                 // 🔥 even if JSON fails → assume success (since DB saved)
//                 setModalMsg("Saved successfully!");
//                 setShowModal(true);
//                 fetchHistory();
//                 return;
//             }

//             // ✅ flexible success handling
//             if (data.success || data.status === "ok") {
//                 setModalMsg("Saved successfully!");
//                 setShowModal(true);
//                 fetchHistory();
//             } else {
//                 alert("Something went wrong: " + (data.message || text));
//             }

//         } catch (err) {
//             console.error(err);
//             alert("Network error. Failed to save.");
//         } finally {
//             setIsSyncing(false);
//         }
//     };


//     const submitSelfReview = async (e) => {
//         e.preventDefault();
//         setIsSyncing(true);
//         try {
//             const res = await fetch('/gt-api/submit_employee_review.php', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 credentials: "include",
//                 body: JSON.stringify({
//                     empid: userData.EmpId,
//                     full_name: userData.DisplayName,
//                     team: userData.Department,
//                     job_title: reviewData.job_title,
//                     review_period: reviewData.review_period,
//                     achievements: reviewData.achievements,
//                     responsibilities: reviewData.responsibilities,
//                     skills_growth: reviewData.skills_growth,
//                     challenges: reviewData.challenges,
//                     improvement_areas: reviewData.improvement_areas,
//                     goals_next_year: reviewData.goals_next_year,
//                     additional_contributions: reviewData.additional_contributions,
//                     support_needed: reviewData.support_needed
//                 })
//             });
//             const data = await res.json();

//             if (data.success) {
//                 setModalMsg("Your self-review has been submitted successfully!");
//                 setShowModal(true);
//             } else {
//                 alert("Failed to submit review: " + data.message);
//             }
//         } catch { alert("Network error. Failed to submit review."); } finally { setIsSyncing(false); }
//     };

//     const canEditOKR =
//         (
//             (!isTimelineLockedFromDB && workflowStep === 'Planning') ||
//             workflowStep === 'Returned_To_Employee'
//         ) &&
//         selectedQuarter !== "";

//     const canScore =
//         workflowStep === 'Scoring' &&
//         (workflowStep === 'Scoring') &&
//         selectedQuarter !== "";
//     const updateProgress = async () => {
//         if (!selectedYear || !selectedQuarter) return;

//         setIsSyncing(true);

//         try {
//             const res = await fetch('/gt-api/update_okr_progress.php', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 credentials: "include",
//                 body: JSON.stringify({
//                     empId: userData.EmpId,
//                     year: selectedYear,
//                     quarter: selectedQuarter,
//                     okrData: okrRows
//                 })
//             });

//             const data = await res.json();

//             console.log("SERVER RESPONSE:", data);

//             if (data.success) {
//                 setModalMsg("Progress updated successfully!");
//                 setShowModal(true);

//                 // ❌ old (keep or remove, doesn't matter)
//                 localStorage.setItem("okr_updated", Date.now());

//                 // ✅ ADD THIS (THIS IS THE REAL FIX)
//                 window.dispatchEvent(new Event("okrUpdated"));
//             }
//         } catch (err) {
//             console.error(err);
//             alert("Network error");
//         } finally {
//             setIsSyncing(false);
//         }
//     };
//     const isEmployeeTurn = ['Planning', 'Scoring', 'Returned_To_Employee'].includes(workflowStep);

//     const isLocked = workflowStep === 'Locked' || workflowStep === 'Sign_Off';



//     const renderSubModule = () => {
//         switch (activeTab) {
//             case "OKR Tracker":
//                 return (
//                     <div className="okr-genesis-container">
//                         {showModal && createPortal(
//                             <div className="okrmodaloverlay" style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'fixed', inset: 0, zIndex: 100000 }}>
//                                 <div className="okr-success-modal animate-pop" style={{ backgroundColor: '#ffffff', padding: '40px', borderRadius: '16px', textAlign: 'center', maxWidth: '400px', width: '90%', boxShadow: '0 20px 40px rgba(0,0,0,0.2)' }}>
//                                     <div className="success-icon-container" style={{ backgroundColor: '#e8f5e9', width: '60px', height: '60px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
//                                         <div className="check-mark" style={{ color: '#2e7d32', fontSize: '30px', fontWeight: 'bold' }}>✓</div>
//                                     </div>
//                                     <h2 style={{ color: '#1a1a1a', marginBottom: '10px', fontSize: '1.5rem' }}>All Set!</h2>
//                                     <p style={{ color: '#666666', marginBottom: '30px', lineHeight: '1.5' }}>{modalMsg}</p>
//                                     <button className="btn-modal-continue" onClick={() => window.location.reload()} style={{ backgroundColor: '#2196F3', color: '#ffffff', border: 'none', padding: '12px 30px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', width: '100%' }}>CONTINUE</button>
//                                 </div>
//                             </div>,
//                             document.body
//                         )}

//                         <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
//                             <div className="okr-glass-card" style={{ width: '100%' }}>
//                                 <header className="okr-view-header">
//                                     <div className="title-group">
//                                         <div className="status-badge"><span className="pulse-ring"></span></div>
//                                         <h1>OKR <span className="blue-gradient-text">Tracker</span></h1>
//                                     </div>
//                                     <div className="header-actions">
//                                         <select className="time-select-modern" value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
//                                             {yearOptions.map(y => <option key={y} value={y}>{y}</option>)}
//                                         </select>

//                                         <select
//                                             className="time-select-modern"
//                                             value={selectedQuarter}
//                                             onChange={(e) => setSelectedQuarter(e.target.value)}
//                                         >
//                                             <option value="" disabled>Select Quarter</option>

//                                             {quarterOptions.map(q => {
//                                                 const currentQuarter = getCurrentQuarterLimit(currentMonth);
//                                                 const isCurrentYear = selectedYear === getFY(today);

//                                                 const isFutureQuarter =
//                                                     isCurrentYear &&
//                                                     quarterOptions.indexOf(q) > quarterOptions.indexOf(currentQuarter);

//                                                 // 🔥 USE EXISTING STATE (NO NEW API)
//                                                 const isLockedFromDB =
//                                                     selectedQuarter === q && isTimelineLockedFromDB;

//                                                 const isDisabled = isFutureQuarter || isLockedFromDB;

//                                                 return (
//                                                     <option key={q} value={q} disabled={isDisabled}>
//                                                         {q} {isLockedFromDB ? "🔒 Locked" : ""}
//                                                     </option>
//                                                 );
//                                             })}
//                                         </select>

//                                         <span className="node-count">
//                                             {userData ? `${userData.DisplayName.toUpperCase()} | ${isLocked ? 'LOCKED' : workflowStep.replace(/_/g, ' ')}` : "CONNECTING..."}
//                                         </span>
//                                     </div>
//                                 </header>

//                                 <div className="okr-table-wrapper">
//                                     <table className="okr-modern-table">
//                                         <thead>
//                                             <tr><th width="35%">Goal Objective</th><th width="45%">Key Results (6)</th><th width="20%">Status</th></tr>
//                                         </thead>
//                                         <tbody>
//                                             {okrRows.map((row, rowIdx) => (
//                                                 <React.Fragment key={row.id}>
//                                                     {row.keyResults.map((kr, idx) => (
//                                                         <tr
//                                                             key={kr._krId || `${row.id}-${idx}`}
//                                                             className={`data-row ${idx === row.keyResults.length - 1 ? 'block-end' : ''}`}
//                                                         >
//                                                             {idx === 0 && (
//                                                                 <td rowSpan={row.keyResults.length} className="objective-spanned-cell">
//                                                                     <div className="obj-header-row">
//                                                                         <div className="obj-number">
//                                                                             Goal {rowIdx + 1}
//                                                                         </div>

//                                                                         {(
//                                                                             (workflowStep === 'Returned_To_Employee') ||
//                                                                             !isTimelineLockedFromDB
//                                                                         ) && canEditOKR && okrRows.length > 1 && (
//                                                                                 <button
//                                                                                     className="btn-delete-obj"
//                                                                                     onClick={() => deleteObjective(row.id)}
//                                                                                     style={{
//                                                                                         background: "rgba(255, 77, 77, 0.1)",
//                                                                                         color: "#ff4d4d",
//                                                                                         border: "1px solid rgba(255, 77, 77, 0.2)",
//                                                                                         width: "24px",
//                                                                                         height: "24px",
//                                                                                         borderRadius: "50%",
//                                                                                         cursor: "pointer",
//                                                                                         display: "flex",
//                                                                                         alignItems: "center",
//                                                                                         justifyContent: "center",
//                                                                                         padding: "0"
//                                                                                     }}
//                                                                                 >
//                                                                                     <Trash2 size={14} style={{ color: '#ff4d4d', display: 'block' }} />
//                                                                                 </button>
//                                                                             )}
//                                                                     </div>

//                                                                     <textarea
//                                                                         className="obj-textarea"
//                                                                         placeholder={
//                                                                             selectedQuarter
//                                                                                 ? "What is your main focus?..."
//                                                                                 : "Select a quarter to begin..."
//                                                                         }
//                                                                         value={row.objective}
//                                                                         disabled={!canEditOKR}
//                                                                         onChange={(e) => {
//                                                                             handleInputChange(row.id, 'objective', e.target.value);
//                                                                             autoResize(e.target);
//                                                                         }}
//                                                                     />
//                                                                 </td>
//                                                             )}

//                                                             <td className="kr-cell">
//                                                                 <div className="kr-input-wrapper">
//                                                                     <span className="kr-index">
//                                                                         0{idx + 1}
//                                                                     </span>

//                                                                     <textarea
//                                                                         className="kr-single-textarea"
//                                                                         placeholder="Key measure..."
//                                                                         value={kr.text}
//                                                                         disabled={!canEditOKR}
//                                                                         onChange={(e) => {
//                                                                             handleInputChange(row.id, 'text', e.target.value, idx);
//                                                                             autoResize(e.target);
//                                                                         }}
//                                                                     />
//                                                                 </div>

//                                                                 {kr.ar_comment && (
//                                                                     <div
//                                                                         style={{
//                                                                             marginTop: '6px',
//                                                                             padding: '8px',
//                                                                             borderRadius: '6px',
//                                                                             background: 'rgba(255,152,0,0.08)',
//                                                                             borderLeft: '3px solid #ff9800',
//                                                                             fontSize: '12px',
//                                                                         }}
//                                                                     >
//                                                                         <strong>AR:</strong> {kr.ar_comment}
//                                                                     </div>
//                                                                 )}
//                                                             </td>

//                                                             <td>
//                                                                 <select
//                                                                     className="modern-select"
//                                                                     value={kr.result}
//                                                                     disabled={!canScore}
//                                                                     onChange={(e) =>
//                                                                         handleInputChange(row.id, 'result', e.target.value, idx)
//                                                                     }
//                                                                 >
//                                                                     {resultOptions.map((opt) => (
//                                                                         <option key={opt} value={opt}>
//                                                                             {opt}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             </td>
//                                                         </tr>
//                                                     ))}
//                                                 </React.Fragment>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>

//                                 <footer className="okr-footer">
//                                     <div className="footer-left">
//                                         {((workflowStep === 'Returned_To_Employee') || !isTimelineLockedFromDB) && canEditOKR && okrRows.length < 6 && (
//                                             <button className="btn-add-objective" onClick={addNewObjective}>+ Add another Goal ({okrRows.length}/6)</button>
//                                         )}
//                                     </div>
//                                     <div className="footer-right">

//                                         {/* 🔥 NEW BUTTON */}
//                                         {canScore && !isLocked && (
//                                             <button
//                                                 className="btn-secondary"
//                                                 onClick={updateProgress}
//                                                 disabled={isSyncing}
//                                             >
//                                                 {isSyncing ? "Updating..." : "Update Progress"}
//                                             </button>
//                                         )}

//                                         {/* EXISTING BUTTON */}
//                                         {selectedQuarter &&
//                                             isEmployeeTurn &&
//                                             !isLocked &&
//                                             (
//                                                 workflowStep === 'Returned_To_Employee' ||
//                                                 workflowStep === 'Scoring' ||
//                                                 !isTimelineLockedFromDB
//                                             ) && (
//                                                 <button className="btn-primary" onClick={syncToGenesis} disabled={isSyncing}>
//                                                     {isSyncing
//                                                         ? "Saving..."
//                                                         : workflowStep === 'Returned_To_Employee'
//                                                             ? "Resubmit"
//                                                             : workflowStep === 'Planning'
//                                                                 ? "Send for Review"
//                                                                 : "Submit"}
//                                                 </button>
//                                             )}

//                                     </div>
//                                 </footer>
//                             </div>

//                             <div className="okr-glass-card" style={{ width: '100%', padding: '20px' }}>
//                                 <h3 className="blue-gradient-text" style={{ fontSize: '1.1rem', marginBottom: '15px' }}>MY HISTORY</h3>
//                                 <div className="okr-table-wrapper">
//                                     {isTimelineLockedFromDB && (
//                                         <div style={{
//                                             background: "#ff4d4f",
//                                             color: "#fff",
//                                             padding: "10px",
//                                             borderRadius: "6px",
//                                             textAlign: "center",
//                                             fontWeight: "600",
//                                             marginBottom: "10px"
//                                         }}>
//                                             🔒 This quarter is locked by management
//                                         </div>
//                                     )}
//                                     <table className="okr-modern-table">
//                                         <thead>
//                                             <tr><th>Period</th><th>Submitted On</th><th>Status</th><th style={{ textAlign: 'right' }}>Action</th></tr>
//                                         </thead>
//                                         <tbody>
//                                             {history.map((item) => (
//                                                 <tr key={item.id} className="data-row">
//                                                     <td style={{ fontWeight: '600' }}>{item.quarter} {item.year}</td>
//                                                     <td style={{ opacity: 0.6 }}>{new Date(item.submitted_at).toLocaleDateString()}</td>
//                                                     <td>
//                                                         <span className="status-pill-mini">
//                                                             {item.workflow_status === 'Locked' || item.workflow_status === 'Sign_Off' ? '🔒 Locked' : item.workflow_status.replace(/_/g, ' ')}
//                                                         </span>
//                                                     </td>
//                                                     <td style={{ textAlign: 'right' }}>
//                                                         <button className="btn-view-data" onClick={() => handleViewFromLog(item.year, item.quarter)}>VIEW DATA</button>
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>


//                             </div>
//                         </div>
//                     </div>
//                 );




//             case "Employee Self Performance Review":
//                 return (
//                     <div className="okr-genesis-container animate-fade">
//                         {showModal && (
//                             <div className="modal-overlay" style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'fixed', inset: 0, zIndex: 1000, backdropFilter: 'blur(10px)' }}>
//                                 <div className="okr-success-modal animate-pop" style={{ background: '#111', border: '1px solid #00bcd4', padding: '40px', borderRadius: '20px', textAlign: 'center', maxWidth: '400px', width: '90%' }}>
//                                     <div style={{ fontSize: '40px', marginBottom: '15px' }}>📋</div>
//                                     <h2 className="blue-gradient-text">Review Submitted</h2>
//                                     <p style={{ color: 'rgba(255,255,255,0.7)', marginBottom: '25px' }}>{modalMsg}</p>
//                                     <button className="btn-modal-continue" onClick={() => window.location.reload()} style={{ background: '#00bcd4', color: '#000', border: 'none', padding: '12px 25px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>OK</button>
//                                 </div>
//                             </div>
//                         )}

//                         <div className="review-document-container" style={{ maxWidth: '950px', margin: '0 auto', paddingBottom: '50px' }}>
//                             <div className="review-doc-paper" style={{ background: 'rgba(255, 255, 255, 0.03)', backdropFilter: 'blur(20px)', border: '1px solid rgba(255, 255, 255, 0.1)', borderRadius: '12px', padding: '50px' }}>

//                                 <div className="doc-header-grid" style={{ display: 'flex', gap: '40px', borderBottom: '2px solid #00bcd4', paddingBottom: '30px', marginBottom: '40px' }}>
//                                     <div className="doc-logo-section">
//                                         <img src={logoImg} alt="Logo" style={{ maxWidth: '140px', height: 'auto', filter: 'brightness(1.2)' }} />
//                                     </div>
//                                     <div className="doc-title-section">
//                                         <h1 style={{ fontSize: '2.2rem', fontWeight: '800', margin: '0 0 10px 0', color: '#fff' }}>Employee Annual Self-Review Form</h1>
//                                         <p style={{ fontSize: '0.95rem', lineHeight: '1.6', opacity: 0.7, color: '#fff' }}>
//                                             Please complete this self-review to reflect on your performance. <strong>Provide 5 points for each section.</strong>
//                                         </p>
//                                     </div>
//                                 </div>

//                                 <form onSubmit={submitSelfReview}>
//                                     <div className="doc-section" style={{ marginBottom: '40px' }}>
//                                         <h3 style={{ color: '#00bcd4', textTransform: 'uppercase', fontSize: '0.85rem', letterSpacing: '2px', marginBottom: '20px' }}>SECTION 1 — Basic Information</h3>
//                                         <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
//                                             <div className="doc-field">
//                                                 <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.6, marginBottom: '5px', color: '#fff' }}>1. Full Name:</label>
//                                                 <input type="text" className="doc-underlined-input" value={userData?.DisplayName} readOnly />
//                                             </div>
//                                             <div className="doc-field">
//                                                 <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.6, marginBottom: '5px', color: '#fff' }}>2. Job Title:</label>
//                                                 <input type="text" className="doc-underlined-input" placeholder="Your Title..." onChange={(e) => setReviewData({ ...reviewData, job_title: e.target.value })} />
//                                             </div>
//                                             <div className="doc-field">
//                                                 <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.6, marginBottom: '5px', color: '#fff' }}>3. Team:</label>
//                                                 <input type="text" className="doc-underlined-input" value={userData?.Department} readOnly />
//                                             </div>
//                                             <div className="doc-field">
//                                                 <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.6, marginBottom: '5px', color: '#fff' }}>4. Review Period:</label>
//                                                 <input type="text" className="doc-underlined-input" placeholder="Jan 2025 – Dec 2025" required onChange={(e) => setReviewData({ ...reviewData, review_period: e.target.value })} />
//                                             </div>
//                                         </div>
//                                     </div>

//                                     {[
//                                         { id: 'achievements', title: 'SECTION 2 — Key Achievements', instruction: 'List your top achievements this year:' },
//                                         { id: 'responsibilities', title: 'SECTION 3 — Role & Responsibilities', instruction: 'Describe your main responsibilities and any additional tasks:' },
//                                         { id: 'skills_growth', title: 'SECTION 4 — Skills & Growth', instruction: 'What new skills or knowledge did you acquire?' },
//                                         { id: 'challenges', title: 'SECTION 5 — Challenges', instruction: 'What challenges did you face and how did you handle them?' },
//                                         { id: 'improvement_areas', title: 'SECTION 6 — Improvement Areas', instruction: 'What areas do you want to improve next year?' },
//                                         { id: 'goals_next_year', title: 'SECTION 7 — Goals for Next Year', instruction: 'List goals you want to work on next year:' },
//                                         { id: 'additional_contributions', title: 'SECTION 8 — Additional Contributions', instruction: 'Mention team support, mentoring, or other initiatives:' },
//                                         { id: 'support_needed', title: 'SECTION 9 — Support Needed', instruction: 'What resources do you need from your manager?' }
//                                     ].map((section) => (
//                                         <div className="doc-section" key={section.id} style={{ marginBottom: '35px' }}>
//                                             <h3 style={{ color: '#00bcd4', textTransform: 'uppercase', fontSize: '0.85rem', letterSpacing: '2px', marginBottom: '10px' }}>{section.title}</h3>
//                                             <p style={{ fontSize: '0.9rem', marginBottom: '15px', fontWeight: '500', color: '#fff' }}>{section.instruction}</p>

//                                             <div className="five-point-container" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
//                                                 {[0, 1, 2, 3, 4].map((idx) => (
//                                                     <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: '15px', background: 'rgba(255,255,255,0.02)', padding: '10px 15px', borderRadius: '4px' }}>
//                                                         <span style={{ fontSize: '0.8rem', opacity: 0.4, color: '#00bcd4', fontWeight: 'bold', marginTop: '4px' }}>{idx + 1}.</span>
//                                                         <textarea
//                                                             placeholder="..."
//                                                             className="doc-point-textarea"
//                                                             rows="1"
//                                                             value={reviewData[section.id][idx]}
//                                                             onChange={(e) => {
//                                                                 handleReviewChange(section.id, idx, e.target.value);
//                                                                 autoResize(e.target);
//                                                             }}
//                                                             style={{
//                                                                 width: '100%',
//                                                                 background: 'transparent',
//                                                                 border: 'none',
//                                                                 color: '#fff',
//                                                                 outline: 'none',
//                                                                 resize: 'none',
//                                                                 overflow: 'hidden',
//                                                                 padding: '0',
//                                                                 lineHeight: '1.5'
//                                                             }}
//                                                         />
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         </div>
//                                     ))}

//                                     <div style={{ textAlign: 'center', marginTop: '50px' }}>
//                                         <button type="submit" className="doc-submit-btn" disabled={isSyncing} style={{ background: '#00bcd4', color: '#000', border: 'none', padding: '18px 60px', borderRadius: '4px', fontWeight: '800', cursor: 'pointer', transition: '0.3s' }}>
//                                             {isSyncing ? "SAVING DATA..." : "SUBMIT COMPLETED REVIEW"}
//                                         </button>
//                                     </div>
//                                 </form>
//                             </div>
//                         </div>
//                     </div>
//                 );

//             case "Manager Review":
//                 return (
//                     <div className="okr-genesis-container animate-fade">
//                         <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
//                             <h2 className="blue-gradient-text">Manager Review</h2>
//                             {managementNotices.reviews.length > 0 ? (
//                                 managementNotices.reviews.map((item, index) => (
//                                     <div key={index} className="okr-glass-card" style={{ padding: '20px', borderLeft: '4px solid #00bcd4' }}>
//                                         <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', opacity: 0.6, fontSize: '0.8rem' }}>
//                                             <span>OFFICIAL REVIEW</span>
//                                             <span>{new Date(item.created_at).toLocaleDateString()}</span>
//                                         </div>
//                                         <div style={{ color: '#fff', whiteSpace: 'pre-wrap', lineHeight: '1.6' }}>{item.content}</div>
//                                     </div>
//                                 ))
//                             ) : (
//                                 <div className="okr-glass-card" style={{ padding: '20px', textAlign: 'center', opacity: 0.5 }}>No reviews found.</div>
//                             )}
//                         </div>
//                     </div>
//                 );

//             case "Probation Period Feedback":
//                 return (
//                     <div className="okr-genesis-container animate-fade">
//                         <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
//                             <h2 className="blue-gradient-text">Probation Notice</h2>
//                             {managementNotices.probations.length > 0 ? (
//                                 managementNotices.probations.map((item, index) => (
//                                     <div key={index} className="okr-glass-card" style={{ padding: '20px', borderLeft: '4px solid #ff5252' }}>
//                                         <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', opacity: 0.6, fontSize: '0.8rem' }}>
//                                             <span>NOTICE OF PROBATION</span>
//                                             <span>{new Date(item.created_at).toLocaleDateString()}</span>
//                                         </div>
//                                         <div style={{ color: '#fff', whiteSpace: 'pre-wrap', lineHeight: '1.6' }}>{item.content}</div>
//                                     </div>
//                                 ))
//                             ) : (
//                                 <div className="okr-glass-card" style={{ padding: '20px', textAlign: 'center', opacity: 0.5 }}>No probation notices found.</div>
//                             )}
//                         </div>
//                     </div>
//                 );



//             default: return null;
//         }
//     };

//     return (
//         <div className="pay-module">
//             <div className="pay-nav-grid">
//                 {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//                     <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => setActiveTab(tab)}>
//                         {tab.toUpperCase()}
//                     </button>
//                 ))}
//             </div>
//             <div className="pay-content-area">
//                 {renderSubModule()}
//             </div>
//         </div>
//     );
// };

// export default OKRTracker;





















import React, { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { Trash2 } from 'lucide-react';
import logoImg from '../assets/logo.jpg';
import '../styles/OKRTracker.css';

const OKRTracker = ({ userData: propUserData, defaultTab }) => {

    const [lockedQuarters, setLockedQuarters] = useState({});

    const [activeTab, setActiveTab] = useState("OKR Tracker");

    /* ---------- FINANCIAL YEAR & QUARTER LOGIC ---------- */
    const today = new Date();
    const currentMonth = today.getMonth() + 1;

    const getFY = (date) => {
        const m = date.getMonth() + 1;
        const y = date.getFullYear();
        return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
    };

    const getCurrentQuarterLimit = (month) => {
        if (month >= 4 && month <= 6) return 'Quarter 1';
        if (month >= 7 && month <= 9) return 'Quarter 2';
        if (month >= 10 && month <= 12) return 'Quarter 3';
        return 'Quarter 4';
    };

    const [userData, setUserData] = useState(null);
    const [isSyncing, setIsSyncing] = useState(false);
    const [isTimelineLockedFromDB, setIsTimelineLockedFromDB] = useState(false);
    const [selectedYear, setSelectedYear] = useState(getFY(today));
    const [selectedQuarter, setSelectedQuarter] = useState("");

    const [history, setHistory] = useState([]);
    const [workflowStep, setWorkflowStep] = useState('Planning');
    const [showModal, setShowModal] = useState(false);
    const [modalMsg, setModalMsg] = useState('');

    /* ---------- EMPLOYEE REVIEW STATE ---------- */
    const [reviewData, setReviewData] = useState({
        review_period: '',
        job_title: '',
        achievements: Array(5).fill(''),
        responsibilities: Array(5).fill(''),
        skills_growth: Array(5).fill(''),
        challenges: Array(5).fill(''),
        improvement_areas: Array(5).fill(''),
        goals_next_year: Array(5).fill(''),
        additional_contributions: Array(5).fill(''),
        support_needed: Array(5).fill('')
    });

    const [okrRows, setOkrRows] = useState([
        {
            id: Date.now(),
            objective: '',
            keyResults: Array.from({ length: 6 }, () => ({ text: '', result: 'Pending' }))
        }
    ]);

    const resultOptions = ['Pending', 'Not Met/ Downgraded', 'Successfull', 'Exceeds', 'Excellence'];
    const quarterOptions = ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'];
    const yearOptions = ["2024-2025", "2025-2026", "2026-2027"];

    /* ---------- AUTO-RESIZE LOGIC ---------- */
    const autoResize = (target) => {
        if (target) {
            target.style.height = 'auto';
            target.style.height = `${target.scrollHeight}px`;
        }
    };

    // Re-run resize when tabs change or data loads
    useEffect(() => {
        const textareas = document.querySelectorAll('.obj-textarea, .kr-single-textarea, .doc-point-textarea');
        textareas.forEach(el => autoResize(el));
    }, [okrRows, activeTab, reviewData]);

    useEffect(() => {
        if (propUserData) {
            setUserData({
                EmpId: propUserData.EmpId || propUserData.id,
                DisplayName: `${propUserData.firstName || ''} ${propUserData.lastName || ''}`.trim(),
                Department: propUserData.Department || ''
            });
        }
    }, [propUserData]);





    useEffect(() => {
        const fetchAllLocks = async () => {
            try {
                const res = await fetch(
                    `/gt-api/get_timeline_lock.php?year=${selectedYear}`,
                    {
                        credentials: "include"
                    }
                );
                const data = await res.json();

                if (data.success && data.data) {
                    const lockMap = {};
                    data.data.forEach(item => {
                        lockMap[item.quarter] = item.locked == 1;
                    });
                    setLockedQuarters(lockMap);
                }
            } catch (err) {
                console.error(err);
            }
        };

        if (selectedYear) fetchAllLocks();
    }, [selectedYear]);

    const loadExistingOKR = useCallback(async (year, quarter, force = false) => {
        if (!userData?.EmpId || !year || !quarter) return;

        try {
            const res = await fetch(
                `/gt-api/get_user_okr.php?empId=${userData.EmpId}&year=${year}&quarter=${quarter}`,
                {
                    credentials: "include"
                }
            );

            const data = await res.json();

            if (data.success) {

                // ✅ DEEP CLONE (VERY IMPORTANT)
                const parsedRaw =
                    typeof data.data === 'string'
                        ? JSON.parse(data.data)
                        : data.data;

                const parsed = JSON.parse(JSON.stringify(parsedRaw));

                // ✅ CLEAN + REBUILD DATA
                const cleanedData = parsed.map((obj) => {
                    return {
                        ...obj,
                        id: obj.id || `${Date.now()}-${Math.random()}`, // 🔥 ensure unique objective id
                        keyResults: Array.from({ length: 6 }, (_, i) => {
                            const kr = obj.keyResults?.[i] || {};

                            const newKR = {
                                text: kr.text ? String(kr.text) : '',
                                result: kr.result ? String(kr.result) : 'Pending',
                                ar_comment: kr.ar_comment ? String(kr.ar_comment) : '',
                                _krId: `${i}-${Date.now()}-${Math.random()}` // 🔥 UNIQUE PER KR
                            };

                            if (
                                data.workflow_status === 'Scoring' ||
                                data.workflow_status === 'Sign_Off' ||
                                data.workflow_status === 'Locked'
                            ) {
                                delete newKR.ar_comment;
                            }

                            return { ...newKR }; // 🔥 force new object
                        })
                    };
                });

                setOkrRows(cleanedData);
                setWorkflowStep(data.workflow_status);

            } else if (force || !data.success) {

                setWorkflowStep('Planning');

                setOkrRows([
                    {
                        id: Date.now(),
                        objective: '',
                        keyResults: Array.from({ length: 6 }, () => ({
                            text: '',
                            result: 'Pending'
                        }))
                    }
                ]);
            }

        } catch (err) {
            console.error(err);
        }
    }, [userData]);

    useEffect(() => {
        if (selectedQuarter) {
            loadExistingOKR(selectedYear, selectedQuarter);
        }
    }, [selectedYear, selectedQuarter, loadExistingOKR]);

    useEffect(() => {
        const fetchLock = async () => {
            try {
                const res = await fetch(
                    `/gt-api/get_timeline_lock.php?year=${selectedYear}&quarter=${selectedQuarter}`,
                    {
                        credentials: "include"
                    }
                );
                const data = await res.json();
                console.log("CHECK LOCK API:", selectedYear, selectedQuarter);

                if (data.success) {
                    setIsTimelineLockedFromDB(data.locked === true || data.locked === "true" || data.locked == 1);
                }
            } catch (err) {
                console.error(err);
            }
        };

        if (selectedYear && selectedQuarter) {
            fetchLock();
        }
    }, [selectedYear, selectedQuarter]);

    const fetchHistory = useCallback(async () => {
        if (!userData?.EmpId) return;
        try {
            const res = await fetch(
                `/gt-api/get_okr_history.php?empId=${userData.EmpId}`,
                {
                    credentials: "include"
                }
            );
            const data = await res.json();
            setHistory(data || []);
        } catch (err) { console.error(err); }
    }, [userData]);

    useEffect(() => {
        fetchHistory();
    }, [fetchHistory]);

    useEffect(() => {
        if (defaultTab) {
            setActiveTab(defaultTab);
        }
    }, [defaultTab]);

    const getQuarterStatusLabel = (q) => {
        const record = history.find(h => h.quarter === q && h.year.toString() === selectedYear.toString());
        if (!record) return "";
        const status = record.workflow_status;
        if (status === 'Locked' || status === 'Sign_Off') return " (Locked)";
        return ` (${status.replace(/_/g, ' ')})`;
    };

    const handleInputChange = (id, field, value, krIndex = null) => {
        setOkrRows(prev => prev.map(row => {
            if (row.id !== id) return row;
            if (krIndex !== null) {
                const krs = [...row.keyResults];
                krs[krIndex] = { ...krs[krIndex], [field]: value };
                return { ...row, keyResults: krs };
            }
            return { ...row, [field]: value };
        }));
    };

    const handleReviewChange = (sectionId, index, value) => {
        setReviewData(prev => {
            const updatedSection = [...prev[sectionId]];
            updatedSection[index] = value;
            return { ...prev, [sectionId]: updatedSection };
        });
    };

    const addNewObjective = () => {
        if (okrRows.length >= 6) return;
        setOkrRows(prev => [...prev, {
            id: Date.now(),
            objective: '',
            keyResults: Array.from({ length: 6 }, () => ({ text: '', result: 'Pending' }))
        }]);
    };

    const deleteObjective = (id) => {
        if (okrRows.length === 1) return;
        setOkrRows(prev => prev.filter(o => o.id !== id));
    };

    const [managementNotices, setManagementNotices] = useState({ reviews: [], probations: [] });

    const fetchNotices = useCallback(async () => {
        if (!userData?.EmpId) return;
        try {
            const res = await fetch(
                `/gt-api/get_manager_feedback.php?empId=${userData.EmpId}`,
                {
                    credentials: "include"
                }
            );
            const data = await res.json();
            if (data.success) {
                setManagementNotices({
                    reviews: data.reviews || [],
                    probations: data.probations || []
                });
            }
        } catch (err) { console.error(err); }
    }, [userData]);

    useEffect(() => {
        if (activeTab === "Manager Review") {
            fetchNotices();
            localStorage.setItem("seen_reviews", new Date().toISOString());
        }

        if (activeTab === "Probation Period Feedback") {
            fetchNotices();
            localStorage.setItem("seen_probation", new Date().toISOString());
        }
    }, [activeTab, fetchNotices]);

    const handleViewFromLog = (year, quarter) => {
        setSelectedYear(year);
        setSelectedQuarter(quarter);
        loadExistingOKR(year, quarter, true);
        setActiveTab("OKR Tracker");
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const syncToGenesis = async () => {
        if (!selectedYear || !selectedQuarter) {
            alert("Please select a quarter first.");
            return;
        }

        if (
            isTimelineLockedFromDB &&
            workflowStep !== 'Returned_To_Employee' &&
            workflowStep !== 'Scoring'
        ) {
            alert("This quarter is locked.");
            return;
        }

        setIsSyncing(true);

        try {
            const res = await fetch('/gt-api/submit_okr.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: "include",
                body: JSON.stringify({
                    empId: userData.EmpId,
                    empName: userData.DisplayName,
                    department: userData.Department,
                    year: selectedYear,
                    quarter: selectedQuarter,
                    okrData: okrRows,
                    status:
                        workflowStep === 'Planning' || workflowStep === 'Returned_To_Employee'
                            ? 'Management_Review'
                            : 'Manager_Scoring_Review'
                })
            });

            const text = await res.text();
            console.log("RAW RESPONSE:", text);

            let data;
            try {
                data = JSON.parse(text);
            } catch {
                // 🔥 even if JSON fails → assume success (since DB saved)
                setModalMsg("Saved successfully!");
                setShowModal(true);
                fetchHistory();
                return;
            }

            // ✅ flexible success handling
            if (data.success || data.status === "ok") {
                setModalMsg("Saved successfully!");
                setShowModal(true);
                fetchHistory();
            } else {
                alert("Something went wrong: " + (data.message || text));
            }

        } catch (err) {
            console.error(err);
            alert("Network error. Failed to save.");
        } finally {
            setIsSyncing(false);
        }
    };


    const submitSelfReview = async (e) => {
        e.preventDefault();
        setIsSyncing(true);
        try {
            const res = await fetch('/gt-api/submit_employee_review.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: "include",
                body: JSON.stringify({
                    empid: userData.EmpId,
                    full_name: userData.DisplayName,
                    team: userData.Department,
                    job_title: reviewData.job_title,
                    review_period: reviewData.review_period,
                    achievements: reviewData.achievements,
                    responsibilities: reviewData.responsibilities,
                    skills_growth: reviewData.skills_growth,
                    challenges: reviewData.challenges,
                    improvement_areas: reviewData.improvement_areas,
                    goals_next_year: reviewData.goals_next_year,
                    additional_contributions: reviewData.additional_contributions,
                    support_needed: reviewData.support_needed
                })
            });
            const data = await res.json();

            if (data.success) {
                setModalMsg("Your self-review has been submitted successfully!");
                setShowModal(true);
            } else {
                alert("Failed to submit review: " + data.message);
            }
        } catch { alert("Network error. Failed to submit review."); } finally { setIsSyncing(false); }
    };

    const canEditOKR =
        (
            (!isTimelineLockedFromDB && workflowStep === 'Planning') ||
            workflowStep === 'Returned_To_Employee'
        ) &&
        selectedQuarter !== "";

    const canScore =
        workflowStep === 'Scoring' &&
        (workflowStep === 'Scoring') &&
        selectedQuarter !== "";
    const updateProgress = async () => {
        if (!selectedYear || !selectedQuarter) return;

        setIsSyncing(true);

        try {
            const res = await fetch('/gt-api/update_okr_progress.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: "include",
                body: JSON.stringify({
                    empId: userData.EmpId,
                    year: selectedYear,
                    quarter: selectedQuarter,
                    okrData: okrRows
                })
            });

            const data = await res.json();

            console.log("SERVER RESPONSE:", data);

            if (data.success) {
                setModalMsg("Progress updated successfully!");
                setShowModal(true);

                // ❌ old (keep or remove, doesn't matter)
                localStorage.setItem("okr_updated", Date.now());

                // ✅ ADD THIS (THIS IS THE REAL FIX)
                window.dispatchEvent(new Event("okrUpdated"));
            }
        } catch (err) {
            console.error(err);
            alert("Network error");
        } finally {
            setIsSyncing(false);
        }
    };
    const isEmployeeTurn = ['Planning', 'Scoring', 'Returned_To_Employee'].includes(workflowStep);

    const isLocked = workflowStep === 'Locked' || workflowStep === 'Sign_Off';



    const renderSubModule = () => {
        switch (activeTab) {
            case "OKR Tracker":
                return (
                    <div className="okr-genesis-container">
                        {showModal && createPortal(
                            <div className="okrmodaloverlay" style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'fixed', inset: 0, zIndex: 100000 }}>
                                <div className="okr-success-modal animate-pop" style={{ backgroundColor: '#ffffff', padding: '40px', borderRadius: '16px', textAlign: 'center', maxWidth: '400px', width: '90%', boxShadow: '0 20px 40px rgba(0,0,0,0.2)' }}>
                                    <div className="success-icon-container" style={{ backgroundColor: '#e8f5e9', width: '60px', height: '60px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
                                        <div className="check-mark" style={{ color: '#2e7d32', fontSize: '30px', fontWeight: 'bold' }}>✓</div>
                                    </div>
                                    <h2 style={{ color: '#1a1a1a', marginBottom: '10px', fontSize: '1.5rem' }}>All Set!</h2>
                                    <p style={{ color: '#666666', marginBottom: '30px', lineHeight: '1.5' }}>{modalMsg}</p>
                                    <button className="btn-modal-continue" onClick={() => window.location.reload()} style={{ backgroundColor: '#2196F3', color: '#ffffff', border: 'none', padding: '12px 30px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', width: '100%' }}>CONTINUE</button>
                                </div>
                            </div>,
                            document.body
                        )}

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
                            <div className="okr-glass-card" style={{ width: '100%' }}>
                                <header className="okr-view-header">
                                    <div className="title-group">
                                        <div className="status-badge"><span className="pulse-ring"></span></div>
                                        <h1>OKR <span className="blue-gradient-text">Tracker</span></h1>
                                    </div>
                                    <div className="header-actions">
                                        <select className="time-select-modern" value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
                                            {yearOptions.map(y => <option key={y} value={y}>{y}</option>)}
                                        </select>

                                        <select
                                            className="time-select-modern"
                                            value={selectedQuarter}
                                            onChange={(e) => setSelectedQuarter(e.target.value)}
                                        >
                                            <option value="" disabled>Select Quarter</option>

                                            {quarterOptions.map(q => {
                                                const currentQuarter = getCurrentQuarterLimit(currentMonth);
                                                const isCurrentYear = selectedYear === getFY(today);

                                                const isFutureQuarter =
                                                    isCurrentYear &&
                                                    quarterOptions.indexOf(q) > quarterOptions.indexOf(currentQuarter);

                                                // 🔥 USE EXISTING STATE (NO NEW API)
                                                const isLockedFromDB =
                                                    selectedQuarter === q && isTimelineLockedFromDB;

                                                const isDisabled = isFutureQuarter || isLockedFromDB;

                                                return (
                                                    <option key={q} value={q} disabled={isDisabled}>
                                                        {q} {isLockedFromDB ? "🔒 Locked" : ""}
                                                    </option>
                                                );
                                            })}
                                        </select>

                                        <span className="node-count">
                                            {userData ? `${userData.DisplayName.toUpperCase()} | ${isLocked ? 'LOCKED' : workflowStep.replace(/_/g, ' ')}` : "CONNECTING..."}
                                        </span>
                                    </div>
                                </header>

                                <div className="okr-table-wrapper">
                                    <table className="okr-modern-table">
                                        <thead>
                                            <tr><th width="35%">Goal Objective</th><th width="45%">Key Results (6)</th><th width="20%">Status</th></tr>
                                        </thead>
                                        <tbody>
                                            {okrRows.map((row, rowIdx) => (
                                                <React.Fragment key={row.id}>
                                                    {row.keyResults.map((kr, idx) => (
                                                        <tr
                                                            key={kr._krId || `${row.id}-${idx}`}
                                                            className={`data-row ${idx === row.keyResults.length - 1 ? 'block-end' : ''}`}
                                                        >
                                                            {idx === 0 && (
                                                                <td rowSpan={row.keyResults.length} className="objective-spanned-cell">
                                                                    <div className="obj-header-row">
                                                                        <div className="obj-number">
                                                                            Goal {rowIdx + 1}
                                                                        </div>

                                                                        {(
                                                                            (workflowStep === 'Returned_To_Employee') ||
                                                                            !isTimelineLockedFromDB
                                                                        ) && canEditOKR && okrRows.length > 1 && (
                                                                                <button
                                                                                    className="btn-delete-obj"
                                                                                    onClick={() => deleteObjective(row.id)}
                                                                                    style={{
                                                                                        background: "rgba(255, 77, 77, 0.1)",
                                                                                        color: "#ff4d4d",
                                                                                        border: "1px solid rgba(255, 77, 77, 0.2)",
                                                                                        width: "24px",
                                                                                        height: "24px",
                                                                                        borderRadius: "50%",
                                                                                        cursor: "pointer",
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center",
                                                                                        padding: "0"
                                                                                    }}
                                                                                >
                                                                                    <Trash2 size={14} style={{ color: '#ff4d4d', display: 'block' }} />
                                                                                </button>
                                                                            )}
                                                                    </div>

                                                                    <textarea
                                                                        className="obj-textarea"
                                                                        placeholder={
                                                                            selectedQuarter
                                                                                ? "What is your main focus?..."
                                                                                : "Select a quarter to begin..."
                                                                        }
                                                                        value={row.objective}
                                                                        disabled={!canEditOKR}
                                                                        onChange={(e) => {
                                                                            handleInputChange(row.id, 'objective', e.target.value);
                                                                            autoResize(e.target);
                                                                        }}
                                                                    />
                                                                </td>
                                                            )}

                                                            <td className="kr-cell">
                                                                <div className="kr-input-wrapper">
                                                                    <span className="kr-index">
                                                                        0{idx + 1}
                                                                    </span>

                                                                    <textarea
                                                                        className="kr-single-textarea"
                                                                        placeholder="Key measure..."
                                                                        value={kr.text}
                                                                        disabled={!canEditOKR}
                                                                        onChange={(e) => {
                                                                            handleInputChange(row.id, 'text', e.target.value, idx);
                                                                            autoResize(e.target);
                                                                        }}
                                                                    />
                                                                </div>

                                                                {kr.ar_comment && (
                                                                    <div
                                                                        style={{
                                                                            marginTop: '6px',
                                                                            padding: '8px',
                                                                            borderRadius: '6px',
                                                                            background: 'rgba(255,152,0,0.08)',
                                                                            borderLeft: '3px solid #ff9800',
                                                                            fontSize: '12px',
                                                                        }}
                                                                    >
                                                                        <strong>AR:</strong> {kr.ar_comment}
                                                                    </div>
                                                                )}
                                                            </td>

                                                            <td>
                                                                <select
                                                                    className="modern-select"
                                                                    value={kr.result}
                                                                    disabled={!canScore}
                                                                    onChange={(e) =>
                                                                        handleInputChange(row.id, 'result', e.target.value, idx)
                                                                    }
                                                                >
                                                                    {resultOptions.map((opt) => (
                                                                        <option key={opt} value={opt}>
                                                                            {opt}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </React.Fragment>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <footer className="okr-footer">
                                    <div className="footer-left">
                                        {((workflowStep === 'Returned_To_Employee') || !isTimelineLockedFromDB) && canEditOKR && okrRows.length < 6 && (
                                            <button className="btn-add-objective" onClick={addNewObjective}>+ Add another Goal ({okrRows.length}/6)</button>
                                        )}
                                    </div>
                                    <div className="footer-right">

                                        {/* 🔥 NEW BUTTON */}
                                        {canScore && !isLocked && (
                                            <button
                                                className="btn-secondary"
                                                onClick={updateProgress}
                                                disabled={isSyncing}
                                            >
                                                {isSyncing ? "Updating..." : "Update Progress"}
                                            </button>
                                        )}

                                        {/* EXISTING BUTTON */}
                                        {selectedQuarter &&
                                            isEmployeeTurn &&
                                            !isLocked &&
                                            (
                                                workflowStep === 'Returned_To_Employee' ||
                                                workflowStep === 'Scoring' ||
                                                !isTimelineLockedFromDB
                                            ) && (
                                                <button className="btn-primary" onClick={syncToGenesis} disabled={isSyncing}>
                                                    {isSyncing
                                                        ? "Saving..."
                                                        : workflowStep === 'Returned_To_Employee'
                                                            ? "Resubmit"
                                                            : workflowStep === 'Planning'
                                                                ? "Send for Review"
                                                                : "Submit"}
                                                </button>
                                            )}

                                    </div>
                                </footer>
                            </div>

                            <div className="okr-glass-card" style={{ width: '100%', padding: '20px' }}>
                                <h3 className="blue-gradient-text" style={{ fontSize: '1.1rem', marginBottom: '15px' }}>MY HISTORY</h3>
                                <div className="okr-table-wrapper">
                                    {isTimelineLockedFromDB && (
                                        <div style={{
                                            background: "#ff4d4f",
                                            color: "#fff",
                                            padding: "10px",
                                            borderRadius: "6px",
                                            textAlign: "center",
                                            fontWeight: "600",
                                            marginBottom: "10px"
                                        }}>
                                            🔒 This quarter is locked by management
                                        </div>
                                    )}
                                    <table className="okr-modern-table">
                                        <thead>
                                            <tr><th>Period</th><th>Submitted On</th><th>Status</th><th style={{ textAlign: 'right' }}>Action</th></tr>
                                        </thead>
                                        <tbody>
                                            {history.map((item) => (
                                                <tr key={item.id} className="data-row">
                                                    <td style={{ fontWeight: '600' }}>{item.quarter} {item.year}</td>
                                                    <td style={{ opacity: 0.6 }}>{new Date(item.submitted_at).toLocaleDateString()}</td>
                                                    <td>
                                                        <span className="status-pill-mini">
                                                            {item.workflow_status === 'Locked' || item.workflow_status === 'Sign_Off' ? '🔒 Locked' : item.workflow_status.replace(/_/g, ' ')}
                                                        </span>
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <button className="btn-view-data" onClick={() => handleViewFromLog(item.year, item.quarter)}>VIEW DATA</button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>


                            </div>
                        </div>
                    </div>
                );




            case "Employee Self Performance Review":
                return (
                    <div className="okr-genesis-container animate-fade">
                        {showModal && (
                            <div className="modal-overlay" style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'fixed', inset: 0, zIndex: 1000, backdropFilter: 'blur(10px)' }}>
                                <div className="okr-success-modal animate-pop" style={{ background: '#111', border: '1px solid #00bcd4', padding: '40px', borderRadius: '20px', textAlign: 'center', maxWidth: '400px', width: '90%' }}>
                                    <div style={{ fontSize: '40px', marginBottom: '15px' }}>📋</div>
                                    <h2 className="blue-gradient-text">Review Submitted</h2>
                                    <p style={{ color: 'rgba(255,255,255,0.7)', marginBottom: '25px' }}>{modalMsg}</p>
                                    <button className="btn-modal-continue" onClick={() => window.location.reload()} style={{ background: '#00bcd4', color: '#000', border: 'none', padding: '12px 25px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>OK</button>
                                </div>
                            </div>
                        )}

                        <div className="review-document-container" style={{ maxWidth: '950px', margin: '0 auto', paddingBottom: '50px' }}>
                            <div className="review-doc-paper" style={{ background: 'rgba(255, 255, 255, 0.03)', backdropFilter: 'blur(20px)', border: '1px solid rgba(255, 255, 255, 0.1)', borderRadius: '12px', padding: '50px' }}>

                                <div className="doc-header-grid" style={{ display: 'flex', gap: '40px', borderBottom: '2px solid #00bcd4', paddingBottom: '30px', marginBottom: '40px' }}>
                                    <div className="doc-logo-section">
                                        <img src={logoImg} alt="Logo" style={{ maxWidth: '140px', height: 'auto', filter: 'brightness(1.2)' }} />
                                    </div>
                                    <div className="doc-title-section">
                                        <h1 style={{ fontSize: '2.2rem', fontWeight: '800', margin: '0 0 10px 0', color: '#fff' }}>Employee Annual Self-Review Form</h1>
                                        <p style={{ fontSize: '0.95rem', lineHeight: '1.6', opacity: 0.7, color: '#fff' }}>
                                            Please complete this self-review to reflect on your performance. <strong>Provide 5 points for each section.</strong>
                                        </p>
                                    </div>
                                </div>

                                <form onSubmit={submitSelfReview}>
                                    <div className="doc-section" style={{ marginBottom: '40px' }}>
                                        <h3 style={{ color: '#00bcd4', textTransform: 'uppercase', fontSize: '0.85rem', letterSpacing: '2px', marginBottom: '20px' }}>SECTION 1 — Basic Information</h3>
                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
                                            <div className="doc-field">
                                                <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.6, marginBottom: '5px', color: '#fff' }}>1. Full Name:</label>
                                                <input type="text" className="doc-underlined-input" value={userData?.DisplayName} readOnly />
                                            </div>
                                            <div className="doc-field">
                                                <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.6, marginBottom: '5px', color: '#fff' }}>2. Job Title:</label>
                                                <input type="text" className="doc-underlined-input" placeholder="Your Title..." onChange={(e) => setReviewData({ ...reviewData, job_title: e.target.value })} />
                                            </div>
                                            <div className="doc-field">
                                                <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.6, marginBottom: '5px', color: '#fff' }}>3. Team:</label>
                                                <input type="text" className="doc-underlined-input" value={userData?.Department} readOnly />
                                            </div>
                                            <div className="doc-field">
                                                <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.6, marginBottom: '5px', color: '#fff' }}>4. Review Period:</label>
                                                <input type="text" className="doc-underlined-input" placeholder="Jan 2025 – Dec 2025" required onChange={(e) => setReviewData({ ...reviewData, review_period: e.target.value })} />
                                            </div>
                                        </div>
                                    </div>

                                    {[
                                        { id: 'achievements', title: 'SECTION 2 — Key Achievements', instruction: 'List your top achievements this year:' },
                                        { id: 'responsibilities', title: 'SECTION 3 — Role & Responsibilities', instruction: 'Describe your main responsibilities and any additional tasks:' },
                                        { id: 'skills_growth', title: 'SECTION 4 — Skills & Growth', instruction: 'What new skills or knowledge did you acquire?' },
                                        { id: 'challenges', title: 'SECTION 5 — Challenges', instruction: 'What challenges did you face and how did you handle them?' },
                                        { id: 'improvement_areas', title: 'SECTION 6 — Improvement Areas', instruction: 'What areas do you want to improve next year?' },
                                        { id: 'goals_next_year', title: 'SECTION 7 — Goals for Next Year', instruction: 'List goals you want to work on next year:' },
                                        { id: 'additional_contributions', title: 'SECTION 8 — Additional Contributions', instruction: 'Mention team support, mentoring, or other initiatives:' },
                                        { id: 'support_needed', title: 'SECTION 9 — Support Needed', instruction: 'What resources do you need from your manager?' }
                                    ].map((section) => (
                                        <div className="doc-section" key={section.id} style={{ marginBottom: '35px' }}>
                                            <h3 style={{ color: '#00bcd4', textTransform: 'uppercase', fontSize: '0.85rem', letterSpacing: '2px', marginBottom: '10px' }}>{section.title}</h3>
                                            <p style={{ fontSize: '0.9rem', marginBottom: '15px', fontWeight: '500', color: '#fff' }}>{section.instruction}</p>

                                            <div className="five-point-container" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                {[0, 1, 2, 3, 4].map((idx) => (
                                                    <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: '15px', background: 'rgba(255,255,255,0.02)', padding: '10px 15px', borderRadius: '4px' }}>
                                                        <span style={{ fontSize: '0.8rem', opacity: 0.4, color: '#00bcd4', fontWeight: 'bold', marginTop: '4px' }}>{idx + 1}.</span>
                                                        <textarea
                                                            placeholder="..."
                                                            className="doc-point-textarea"
                                                            rows="1"
                                                            value={reviewData[section.id][idx]}
                                                            onChange={(e) => {
                                                                handleReviewChange(section.id, idx, e.target.value);
                                                                autoResize(e.target);
                                                            }}
                                                            style={{
                                                                width: '100%',
                                                                background: 'transparent',
                                                                border: 'none',
                                                                color: '#fff',
                                                                outline: 'none',
                                                                resize: 'none',
                                                                overflow: 'hidden',
                                                                padding: '0',
                                                                lineHeight: '1.5'
                                                            }}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}

                                    <div style={{ textAlign: 'center', marginTop: '50px' }}>
                                        <button type="submit" className="doc-submit-btn" disabled={isSyncing} style={{ background: '#00bcd4', color: '#000', border: 'none', padding: '18px 60px', borderRadius: '4px', fontWeight: '800', cursor: 'pointer', transition: '0.3s' }}>
                                            {isSyncing ? "SAVING DATA..." : "SUBMIT COMPLETED REVIEW"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                );

            case "Manager Review":
                return (
                    <div className="okr-genesis-container animate-fade">
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
                            <h2 className="blue-gradient-text">Manager Review</h2>
                            {managementNotices.reviews.length > 0 ? (
                                managementNotices.reviews.map((item, index) => (
                                    <div key={index} className="okr-glass-card" style={{ padding: '20px', borderLeft: '4px solid #00bcd4' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', opacity: 0.6, fontSize: '0.8rem' }}>
                                            <span>OFFICIAL REVIEW</span>
                                            <span>{new Date(item.created_at).toLocaleDateString()}</span>
                                        </div>
                                        <div style={{ color: '#fff', whiteSpace: 'pre-wrap', lineHeight: '1.6' }}>{item.content}</div>
                                    </div>
                                ))
                            ) : (
                                <div className="okr-glass-card" style={{ padding: '20px', textAlign: 'center', opacity: 0.5 }}>No reviews found.</div>
                            )}
                        </div>
                    </div>
                );

            case "Probation Period Feedback":
                return (
                    <div className="okr-genesis-container animate-fade">
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
                            <h2 className="blue-gradient-text">Probation Notice</h2>
                            {managementNotices.probations.length > 0 ? (
                                managementNotices.probations.map((item, index) => (
                                    <div key={index} className="okr-glass-card" style={{ padding: '20px', borderLeft: '4px solid #ff5252' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', opacity: 0.6, fontSize: '0.8rem' }}>
                                            <span>NOTICE OF PROBATION</span>
                                            <span>{new Date(item.created_at).toLocaleDateString()}</span>
                                        </div>
                                        <div style={{ color: '#fff', whiteSpace: 'pre-wrap', lineHeight: '1.6' }}>{item.content}</div>
                                    </div>
                                ))
                            ) : (
                                <div className="okr-glass-card" style={{ padding: '20px', textAlign: 'center', opacity: 0.5 }}>No probation notices found.</div>
                            )}
                        </div>
                    </div>
                );



            default: return null;
        }
    };

    return (
        <div className="pay-module">
            <div className="pay-nav-grid">
                {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
                    <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => setActiveTab(tab)}>
                        {tab.toUpperCase()}
                    </button>
                ))}
            </div>
            <div className="pay-content-area">
                {renderSubModule()}
            </div>
        </div>
    );
};

export default OKRTracker;


